import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  nl: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.auto": "Auto",
      "nav.tarieven": "Tarieven",
      "nav.theoriecursus": "Theoriecursus",
      "nav.contact": "Contact",
      "nav.english": "English",
      "nav.studentPortal": "Portal",
      "nav.dashboard": "Dashboard",
      "nav.exams": "Examens",
      "nav.available_exams": "Beschikbare examens",
      "nav.lessons": "Lessen",
      "nav.students": "Leerlingen",
      "nav.teachers": "Leraren",
      "nav.payments": "Betalingen",
      "nav.agenda": "Mijn Agenda",
      "nav.parameters": "Parameters",
      "nav.navigation": "Navigatie",
      "nav.settings": "Instellingen",
      "nav.my_profile": "Mijn profiel",
      "nav.logout": "Uitloggen",
      "nav.switch_language": "Taal wijzigen",
      "nav.profile": "Profiel",
      "common.cancel": "Annuleren",
      "portal.common.refresh": "Vernieuwen",
      "portal.common.booked": "Geboekt",
      "portal.common.book": "Boeken",
      "portal.common.unassigned": "",
      "portal.common.free": "Vrij",
      "portal.common.house_number": "Huisnummer",
      "portal.common.postcode": "Postcode",
      "portal.common.license_type": "Type rijbewijs",
      "nav.book_lesson": "Les boeken",
        "home.hero.top": "Digitaliseer je volledige rijschool workflow",
        "home.hero.middle": "Alles-in-één platform voor rijschoolbeheer",
        "home.hero.bottom": "€1 / student / maand",
        "home.features.booking": "Lessen boeken",
        "home.features.exams": "Examens",
        "home.features.payments": "Betalingen",
        "home.hero.see_how": "Zie hoe",
        "home.title": "DriveSchool Portal",
        "home.subtitle": "Alles-in-één cloudplatform voor rijscholen, instructeurs en leerlingen.",
        "home.chip": "Het platform is gratis en slechts €1/maand per leerling!",
        "home.cta": "Begin jouw reis",
        "home.ctaTitle": "Klaar om jouw rijschool te versnellen?",
        "home.ctaDesc": "Meld je aan als instructeur of school en ontgrendel alle portaalfuncties gratis. Voeg leerlingen toe, beheer lessen en geef je bedrijf een boost voor slechts €1/maand per leerling!",
        "home.ctaButton": "Nu registreren",
        "home.features.cbr": "CBR Gecertificeerd",
        "home.features.scheduling": "Slimme Planning",
        "home.stats.instructors": "Instructeurs",
        "home.stats.students": "Leerlingen",
        "home.stats.schools": "Rijscholen",
        // How it works (HomeLandingPage)
        "home.how.title": "Hoe het werkt",
        "home.how.cta": "Ontdekken",
        "home.how.lead": "Why DaaS?",
        "home.how.sub": "Digitaliseer je volledige rijschool workflow op één plek.",
        "home.how.cards.0.title": "Eenvoudig lessen boeken",
        "home.how.cards.0.desc": "Leerlingen kunnen de beschikbaarheid van instructeurs bekijken en online lessen boeken, met automatische updates.",
        "home.how.cards.1.title": "Beheer lessen en leerlingen",
        "home.how.cards.1.desc": "Scholen en instructeurs kunnen leerlingen toevoegen/verwijderen, roosters plannen, voortgang bijhouden en maandelijks gedetailleerde rapporten ontvangen.",
        "home.how.cards.2.title": "Veilig, betrouwbaar en gecertificeerd",
        "home.how.cards.2.desc": "Alle instructeurs zijn geverifieerd en leerlinggegevens worden veilig beschermd. Geïntegreerd met officiële CBR‑examens en optionele faalangstbegeleiding.",
        "home.how.cards.3.title": "Transparante prijzen",
        "home.how.cards.3.desc": "Duidelijke maandelijkse tarieven voor scholen en instructeurs, geen verborgen kosten. Leerlingen betalen alleen voor hun eigen gekozen pakketten of losse lessen.",
        "home.student.title": "Gratis voor leerlingen",
        "home.student.lead": "",
        "home.student.desc": "Beheer je lessen, volg je voort voortgang en communiceer eenvoudig met je instructeur. Het is volledig gratis voor leerlingen.",
        "home.student.referral": "Verwijs je rijschool of instructeur naar DaaS en ontvang korting op je volgende rijles zodra ze zich aanmelden!",
        "home.student.referral_reward": "Referral Beloning",
        "home.student.cta": "Word nu lid als leerling",
        "home.benefits.tag": "Waarom DaaS?",
        "home.benefits.title": "Het alles-in-één rijschoolbeheersysteem",
        "home.benefits.price": "€1/student per maand.",
        "home.benefits.items.0.title": "Slimme Planning",
        "home.benefits.items.0.desc": "Beheer effectief lesmomenten en de beschikbaarheid van docenten.",
        "home.benefits.items.1.title": "Geautomatiseerde Facturatie",
        "home.benefits.items.1.desc": "Word sneller betaald met geïntegreerde facturatie en het bijhouden van betalingen.",
        "home.benefits.items.2.title": "CBR Connectiviteit",
        "home.benefits.items.2.desc": "Importeer examens en resultaten direct in uw workflow.",
        
        "home.register.welcome": "Leuk dat je DaaS wilt proberen!",
        "home.register.motivation": "Bespaar tijd op administratie, focus op lesgeven. Sluit je aan bij 1000+ instructeurs die hun rijscholen revolutioneren met DaaS!",
        
        "home.student.register.welcome": "Alles voor je rijbewijs op één plek",
        "home.student.register.motivation": "Van je eerste theorie-examen tot je praktijkexamen: wij helpen je sneller en slimmer de weg op.",
        "home.student.register.benefit1.title": "De beste rijschool",
        "home.student.register.benefit1.desc": "Vind eenvoudig de beste rijschool die perfect bij jouw wensen en budget past.",
        "home.student.register.benefit2.title": "Theorie & Praktijk",
        "home.student.register.benefit2.desc": "Bereid je optimaal voor op je theorie-examens en volg je voortgang in je lessen.",
        "home.student.register.benefit3.title": "Kijk lessen terug",
        "home.student.register.benefit3.desc": "Verbeter je rijvaardigheid door je lessen terug te kijken en feedback te analyseren.",
        "home.student.register.benefit4.title": "Eenvoudig Plannen",
        "home.student.register.benefit4.desc": "Boek en beheer je rijlessen direct online wanneer het jou uitkomt.",
        
        // Portal Registration (NL)
        "portal.register.title": "Rijschool Registratie",
        "portal.register.teacher_title": "Registreer als instructeur",
        "portal.register.student_title": "Registreer als leerling",
        "portal.register.subtitle": "Sluit je aan bij onze gemeenschap van instructeurs",
        "portal.register.first_name": "Voornaam",
        "portal.register.first_name_placeholder": "Je voornaam",
        "portal.register.last_name": "Achternaam",
        "portal.register.last_name_placeholder": "Je achternaam",
        "portal.register.driving_school_name": "Naam Rijschool",
        "portal.register.driving_school_placeholder": "De naam van jouw rijschool",
        "portal.register.postcode": "Postcode",
        "portal.register.postcode_placeholder": "Je postcode",
        "portal.register.house_number": "Huisnummer",
        "portal.register.house_number_placeholder": "Je huisnummer",
        "portal.register.license_type": "Type rijbewijs",
        "portal.register.license_am": "Bromfiets (AM)",
        "portal.register.license_a1": "Motor lichte (A1)",
        "portal.register.license_a2": "Motor middelzware (A2)",
        "portal.register.license_a": "Motor zware (A)",
        "portal.register.license_b_manual": "Auto (B) - Handgeschakeld",
        "portal.register.license_b_automatic": "Auto (B) - Automaat",
        "portal.register.license_be": "Auto met aanhangwagen (BE)",
        "portal.register.license_b_plus": "Auto met zware aanhangwagen (B+)",
        "portal.register.license_c1": "Vrachtauto lichte (C1)",
        "portal.register.license_c1e": "Vrachtauto lichte met aanhangwagen (C1E)",
        "portal.register.license_c": "Vrachtauto (C)",
        "portal.register.license_ce": "Vrachtauto met aanhangwagen (CE)",
        "portal.register.license_d1": "Bus lichte (D1)",
        "portal.register.license_d1e": "Bus lichte met aanhangwagen (D1E)",
        "portal.register.license_d": "Bus (D)",
        "portal.register.license_de": "Bus met aanhangwagen (DE)",
        "portal.register.license_t": "Tractor (T)",
        "portal.register.license_manual": "Handgeschakeld",
        "portal.register.license_automatic": "Automaat",
        "portal.register.email": "E-mailadres",
        "portal.register.email_placeholder": "jouw@email.com",
        "portal.register.password": "Wachtwoord",
        "portal.register.password_placeholder": "••••••••",
        "portal.register.submit": "Nu Registreren",
        "portal.register.loading": "Account aanmaken...",
        "portal.register.success": "Registratie geslaagd! Controleer je e-mail om je account te verifiëren.",
        "portal.register.have_account": "Heb je al een account? Inloggen",
        "portal.register.no_commitment": "Aanmelden is vrijblijvend. Je zit nergens aan vast.",
        "portal.register.no_commitment_student": "Aanmelden is vrijblijvend.",
        "portal.register.switch_to_student": "Ben je een leerling? Registreer hier",
        "portal.register.switch_to_teacher": "Ben je een instructeur? Registreer hier",
        "portal.register.student": "Leerling",
        "portal.register.teacher": "Leraar",
        "portal.register.administrator": "Beheerder",
        "portal.register.select_license": "Selecteer type rijbewijs",
        "portal.register.interests": "Wat wil je leren?",
        "portal.register.interests_placeholder": "Kies wat je wilt leren",
        "portal.register.interest_theory": "Theorie",
        "portal.register.interest_practical": "Praktijk",
        "portal.register.interest_tips": "Tips",
        "home.student.register.title": "Word lid als leerling",
        "home.student.register.subtitle": "Begin vandaag nog met je rijlessen",
        
        // Portal Login (NL)
        "portal.login.username": "E-mail of Gebruikersnaam",
        "portal.login.username_placeholder": "Je e-mail of gebruikersnaam",
        "portal.login.password": "Wachtwoord",
        "portal.login.username_required": "E-mail of gebruikersnaam is verplicht",
        "portal.login.password_required": "Wachtwoord is verplicht",
        "portal.login.submit": "Inloggen",
        "portal.login.forgot_password": "Wachtwoord vergeten?",
        "portal.login.forgot_password_title": "Wachtwoord vergeten?",
        "portal.login.forgot_password_subtitle": "Voer je gebruikersnaam en e-mailadres in om een herstellink te ontvangen.",
        "portal.login.email": "E-mailadres",
        "portal.login.send_reset_link": "Stuur herstellink",
        "portal.login.back_to_login": "Terug naar inloggen",
        "portal.login.hide_password": "Wachtwoord verbergen",
        "portal.login.show_password": "Wachtwoord tonen",
        "portal.login.forgot_password_success_default": "Als er een account bestaat voor die gebruikersnaam en e-mail, hebben we instructies voor het opnieuw instellen van het wachtwoord verzonden.",
        "portal.common.sending": "Verzenden...",
      
      // Hero Section
      "hero.title": "Nog niet begonnen met rijlessen?",
      "hero.highlight1": "Hoog slagingspercentage",
      "hero.highlight2": "Gespreid betalen is mogelijk",
      "hero.highlight3": "Ervaren rij-instructeurs",
      
      // Introduction Section
      "intro.title": "Rijlessen in Amsterdam e.o.",
      "intro.description": "Universaldrive is een van de betere rijscholen sinds 2002. We hebben in de loop der jaren een betrouwbare en professionele naam opgebouwd onder de vele tevreden cursisten. We zullen er daarom voor zorgen dat je een passende opleiding kiest door middel van een proefles en dat je na het afronden van je opleiding, zo vlot mogelijk, verkeersveilig en zelfstandig deel kunt nemen aan het verkeer.",
      "intro.button": "Proefles Plannen",
      
      // Services Section
      "services.title": "Services",
      "services.autorijles.title": "Autorijles",
      "services.autorijles.description": "Vakkundige instructeurs en instructrices begeleiden je op plezierige wijze naar je doel: het halen van je rijbewijs en bovenal het zelfstandig goed, veilig en vlot leren autorijden.",
      "services.autorijles.button": "Meer informatie",
      "services.expaten.title": "Expaten",
      "services.expaten.description": "Welkom in Nederland! Heb je (lang) niet gereden? Maak je geen zorgen. Met onze opfris rijlessen helpen we je snel weer op de weg. Heb je al een buitenlands rijbewijs? In sommige gevallen kunt u deze inwisselen voor een Nederlandse rijbewijs. Stuur ons een bericht.",
      "services.expaten.button": "Stuur een bericht",
      "services.theorie.title": "Theorie",
      "services.theorie.description": "Wij adviseren om naast je praktijkles meteen te beginnen met de theorie. Dat is immers de basis waarmee je in het verkeer situaties kunt beoordelen en inschatten.",
      "services.theorie.button": "Theoriecursus",
      
      // Technologies Section
      "technologies.title": "Rijlessen in Amsterdam e.o. Sinds 2002",
      "technologies.description": "Op zoek naar de beste rijschool in Amsterdam en omstreken? Dan ben je bij ons aan het juiste adres. Autorijbewijs halen is misschien wel de meest gewilde doelstelling onder de jeugd van tegenwoordig. Voor de een is het van belang voor het werk, voor de ander vanwege economische redenen voor andere opent het weer andere wegen.",
      "technologies.kpi.founded": "Opgericht",
      "technologies.kpi.years": "Jaar ervaring",
      "technologies.kpi.happy_customers": "Tevreden klanten",
      "technologies.best_driving_school": "Beste rijschool van Amsterdam",
      
      // Tariffs
      "tariffs.title": "AUTO Tarieven",
      "tariffs.manual.title": "AUTO Tarieven (Handschakel)",
      "tariffs.automatic.title": "Automaat Tarieven",
      "tariffs.benefits.high_pass_rate": "Hoog slagingspercentage",
      "tariffs.benefits.installment_payment": "Gespreid betalen is mogelijk",
      "tariffs.benefits.experienced_instructors": "Ervaren rij-instructeurs",
      
      "tariffs.packages.40_lessons": "40 rijlessen",
      "tariffs.packages.30_lessons": "30 rijlessen",
      "tariffs.packages.20_lessons": "20 rijlessen",
      "tariffs.packages.15_lessons": "15 rijlessen",
      "tariffs.packages.10_lessons": "10 rijlessen",
      "tariffs.packages.5_lessons": "5 rijlessen",
      "tariffs.packages.60_minutes": "60 minuten",
      "tariffs.packages.flexible": "Flexibel",
      "tariffs.packages.cbr_exam": "CBR examen",
      "tariffs.packages.choose": "Kiezen",
      "tariffs.packages.you_decide": "Jij bepaalt",
      "tariffs.packages.retake_package": "Herexamen Pakket",
      
      "tariffs.individual.title": "AUTO LOSSE PRIJZEN",
      "tariffs.individual.lesson": "Les",
      "tariffs.individual.price": "Prijs",
      "tariffs.individual.exam": "Examen",
      "tariffs.individual.trial_lesson": "Proefles",
      "tariffs.individual.free": "Gratis",
      "tariffs.individual.lesson_60": "Rijles 60 minuten",
      "tariffs.individual.lesson_90": "Rijles 90 minuten",
      "tariffs.individual.lesson_120": "Rijles 120 minuten",
      "tariffs.individual.ttt_exam": "T.T.T. tussentijdse toets CBR",
      "tariffs.individual.cbr_exam": "CBR examen",
      "tariffs.individual.anxiety_exam": "Faalangst examen",
      "tariffs.individual.bnor_exam": "BNOR examen",
      
      // Auto Page
      "auto.hero.title": "Jij wilt toch ook zelf achter het stuur kunnen?",
      "auto.hero.button": "Proefles Plannen",
      "auto.benefits.high_pass": "Hoog slagingspercentage",
      "auto.benefits.installment": "Gespreid betalen is mogelijk",
      "auto.benefits.experienced": "Ervaren rij-instructeurs",
      "auto.details.title": "Starten met je rijbewijs",
      "auto.details.intro": "Bent u op zoek naar een professioneel autorijschool in Amsterdam?",
      "auto.details.description": "Volg gratis bij ons je eerste autorijles (proefles)! Rijschool Universaldrive geeft autorijlessen in Amsterdam. Bij Universaldrive begeleiden vakkundige instructeurs en instructrices je op plezierige wijze naar je doel: het halen van het autorijbewijs en bovenal het zelfstandig goed, veilig en vlot leren autorijden.",
      "auto.details.more_text": "Er wordt een persoonlijk plan opgesteld na de eerste proefles. Daarbij wordt gekeken naar jouw mogelijkheden en specifieke wensen. We kunnen dan gelijk een inschatting maken van het benodigde aantal lessen.\n\nAutorijlessen krijg je in een uitstekende auto met een vaste instructeur of instructrice. Desgewenst halen we je op van huis en wordt je door de volgende leerling ook weer thuisgebracht. Zo rij je in diverse verkeersgebieden en je leert daarbij ook nog eens extra van elkaar.\n\nNatuurlijk zullen we ook in het examengebied oefenen om je vertrouwd te maken met de situaties die je tijdens het examen kunt tegenkomen.",
      "auto.details.read_more": "Lees meer",
      "auto.details.read_less": "Lees minder",
      "auto.packages.title": "Kies jouw pakket!",
      "auto.packages.pro_max": "PRO MAX",
      "auto.packages.pro": "PRO",
      "auto.packages.premium": "PREMIUM",
      "auto.packages.lessons_40": "40 uur rijles",
      "auto.packages.lessons_30": "30 uur rijles",
      "auto.packages.lessons_20": "20 uur rijles",
      "auto.packages.cbr_exam": "CBR Examen inbegrepen",
      "auto.packages.trial_button": "Proefles",
      "auto.callback.title": "Bel mij Terug",
      "auto.callback.name": "Naam",
      "auto.callback.phone": "Telefoon",
      "auto.callback.submit": "Sturen",
      "auto.callback.auto": "Automaat ",
      "auto.callback.motor": "Handschakel",
      "auto.callback.taxi": "Taxi",
      "auto.callback.theory": "Theoriecursus",
      
      // Reviews Section
      "reviews.title": "Reviews",
      "reviews.description": "Bekijk wat onze studenten van ons vinden.",
      "reviews.google": "Google Reviews",
      "reviews.facebook": "Facebook Reviews",
      
      // Demo Lesson Form
      "demo.title": "Nu een Proef Les Plannen",
      "demo.name": "Naam",
      "demo.phone": "Telephone",
      "demo.email": "E-mail",
      "demo.service": "Dienst",
      "demo.service_auto_manual": "Auto (B) Handschakel",
      "demo.service_auto_automatic": "Auto (B) Automaat",
      "demo.service_theory": "Theoriecursus",
      "demo.submit": "Versturen",
      "demo.error": "Vul alle vereiste velden correct in.",
      "demo.success": "Uw aanvraag is succesvol verzonden! Ons team neemt binnenkort contact met je op!",
      "demo.error_general": "Er is iets misgegaan. Probeer het opnieuw.",

      "portal.lessons.bulk_create.title": "Bulk lessen aanmaken",
      "portal.lessons.bulk_create.start_date": "Startdatum & tijd",
      "portal.lessons.bulk_create.end_date": "Einddatum & tijd",
      "portal.lessons.bulk_create.interval": "Interval (uren)",
      "portal.lessons.bulk_create.duration": "Duur (minuten)",
      "portal.lessons.bulk_create.submit": "Lessen aanmaken",
      "portal.lessons.bulk_create.success": "Bulk lessen succesvol aangemaakt!",
      "portal.lessons.create.success": "Les succesvol aangemaakt!",
      "portal.lessons.bulk_create.error": "Fout bij het aanmaken van bulk lessen.",
      "portal.lessons.add_lesson": "Les toevoegen",
      "portal.lessons.create.title": "Nieuwe les aanmaken",
      "portal.lessons.create.date_time": "Datum & Tijd",
      "portal.lessons.create.duration": "Duur (minuten)",
      "portal.lessons.create.type": "Type les",
      "portal.lessons.create.location": "Locatie",
      "portal.lessons.create.submit": "Les aanmaken",
      "portal.lessons.create.error": "Fout bij het aanmaken van de les.",

      "portal.common.list": "Lijst",
      "portal.common.loading": "Laden…",
      "portal.common.confirm": "Bevestigen",
      "portal.common.cancel": "Annuleren",
      "portal.common.back": "Terug",
      "portal.common.edit_profile": "Profiel bewerken",
      "portal.common.save_changes": "Wijzigingen opslaan",
      "portal.common.creating": "Bezig met maken…",
      "portal.common.view_all": "Toon alles",
      "portal.common.details": "Details",
      "portal.common.tbd": "Nader te bepalen",
      "portal.common.error": "Fout",
      "portal.common.success": "Succes",
      "portal.common.ok": "OK",
      "portal.common.not_authorized": "Niet geautoriseerd",
      "portal.common.unnamed": "Naamloos",
      "portal.common.active": "Actief",
      "portal.common.inactive": "Inactief",
      "portal.common.not_set": "Niet ingesteld",
      "portal.common.submitting": "Bezig met indienen…",
      "portal.common.cancelling": "Bezig met annuleren…",
      "portal.common.and_more": "en {{count}} meer…",
      "portal.common.reviews": "beoordelingen",
      "portal.common.close": "Sluiten",
      "portal.common.edit": "Bewerken",
      "portal.common.no_changes": "Geen wijzigingen om op te slaan",
      "portal.common.edit_to_change": "Bewerken om toe te voegen of te wijzigen",
      "portal.common.discard": "Negeren",
      "portal.common.discard_changes": "Wijzigingen negeren",

      "portal.admin.students.title": "Alle leerlingen",
      "portal.admin.students.add_button": "Leerling toevoegen",
      "portal.admin.students.loading": "Leerlingen laden...",
      "portal.admin.students.empty": "Geen leerlingen gevonden.",
      "portal.admin.students.add_modal_title": "Nieuwe leerling toevoegen",
      "portal.admin.students.first_name_placeholder": "Voornaam leerling",
      "portal.admin.students.last_name_placeholder": "Achternaam leerling",
      "portal.admin.students.email_placeholder": "leerling@voorbeeld.nl",
      "portal.admin.students.create_button": "Leerling aanmaken",
      "portal.admin.students.assign_teacher": "Leraar toewijzen (optioneel)",
      "portal.admin.students.select_teacher": "Selecteer leraar",
      "portal.admin.students.select_type": "Selecteer type",
      "portal.admin.students.not_assigned": "Niet toegewezen",
      "portal.admin.students.assigned_teacher": "Toegewezen leraar",
      "portal.admin.students.lessons_today": "Lessen vandaag",
      "portal.admin.students.today_booked": "Vandaag geboekt",
      "portal.admin.students.completed_lessons": "Voltooide lessen",
      "portal.admin.students.exam_sessions": "Examensessies",
      "portal.admin.teachers.title": "Alle leraren",
      "portal.admin.teachers.add_button": "Leraar toevoegen",
      "portal.admin.teachers.add_modal_title": "Nieuwe leraar toevoegen",
      "portal.admin.teachers.first_name_placeholder": "Voornaam leraar",
      "portal.admin.teachers.last_name_placeholder": "Achternaam leraar",
      "portal.admin.teachers.email_placeholder": "leraar@voorbeeld.nl",
      "portal.admin.teachers.create_button": "Leraar aanmaken",
      "portal.admin.teachers.loading": "Leraren laden...",
      "portal.admin.teachers.empty": "Geen leraren gevonden.",
      "portal.admin.teachers.lessons_today": "Lessen vandaag",
      "portal.admin.teachers.today_booked": "Vandaag geboekt",
      "portal.admin.teachers.completed_lessons": "Voltooide lessen",
      "portal.admin.teachers.exam_sessions": "Examensessies",
      "portal.admin.teachers.deactivate_button": "Leraaraccount deactiveren",

      "portal.teacher.dashboard.welcome": "Welkom terug, {{name}}!",
      "portal.teacher.dashboard.subtitle": "Hier is wat er vandaag gebeurt met je leerlingen.",
      "portal.teacher.dashboard.upcoming_lessons_stat": "Aankomende lessen",
      "portal.teacher.dashboard.active_students_stat": "Actieve leerlingen",
      "portal.teacher.dashboard.avg_rating_stat": "Gem. beoordeling",
      "portal.teacher.dashboard.upcoming_lessons_title": "Aankomende lessen",
      "portal.teacher.dashboard.upcoming_exams_title": "Aankomende examens",
      "portal.teacher.dashboard.passed_exams_title": "Behaalde examens",
      "portal.teacher.dashboard.pending_payments_title": "Openstaande betalingen",
      "portal.teacher.dashboard.payments_verified": "Alle betalingen geverifieerd!",
      "portal.teacher.dashboard.payment_pending": "In afwachting",
      "portal.teacher.dashboard.manage_payments": "Beheer betalingen",
      "portal.teacher.dashboard.quick_actions": "Snelle acties",
      "portal.teacher.dashboard.my_students": "Mijn leerlingen",
      "portal.teacher.dashboard.add_student_hint": "Een tijdelijk wachtwoord en verificatie-e-mail worden naar de leerling verzonden.",
      "portal.teacher.students.title": "Mijn leerlingen",
      "portal.teacher.students.search_placeholder": "Leerlingen zoeken...",
      "portal.teacher.students.loading": "Leerlingen laden...",
      "portal.teacher.students.none_found": "Geen leerlingen gevonden",
      "portal.teacher.students.error_loading": "Laden van leerlingen mislukt",

      "portal.teacher.payments.title_outstanding": "Openstaande betalingen",
      "portal.teacher.payments.title_history": "Betalingsgeschiedenis",
      "portal.teacher.payments.loading_outstanding": "Laden…",
      "portal.teacher.payments.loading_history": "Betalingen laden…",
      "portal.teacher.payments.no_outstanding": "Geen openstaande betalingen.",
      "portal.teacher.payments.no_history": "Geen betalingen om te tonen.",
      "portal.teacher.payments.error_load": "Laden van betalingen mislukt",
      "portal.teacher.payments.error_send_bill": "Verzenden van rekening mislukt",
      "portal.teacher.payments.success_send_bill": "Rekening succesvol verzonden",
      "portal.teacher.payments.last_update": "Laatste update",
      "portal.teacher.payments.sending": "Verzenden...",
      "portal.teacher.payments.send_bill": "Stuur rekening",
      "portal.teacher.payments.student_fallback": "Leerling",

      "portal.student.dashboard.welcome": "Hallo, {{name}}!",
      "portal.student.dashboard.subtitle": "Volg je voortgang en boek je volgende rijles.",
      "portal.student.dashboard.balance_stat": "Saldo",
      "portal.student.dashboard.next_lesson_label": "Volgende les",
      "portal.student.dashboard.next_lesson_at": "om",
      "portal.student.dashboard.minutes_short": "min",
      "portal.student.dashboard.meeting_point": "Ontmoetingspunt",
      "portal.student.dashboard.available_lessons_title": "",
      "portal.student.dashboard.see_more": "Bekijk meer",
      "portal.student.dashboard.no_available_lessons": "Geen lessen beschikbaar op dit moment.",
      "portal.student.dashboard.teacher_feedback_title": "Feedback van instructeur",
      "portal.student.dashboard.no_feedback": "Nog geen feedback. Ga zo door!",
      "portal.student.dashboard.recent_payments_title": "Recente betalingen",
      "portal.student.payments.column_student": "Leerling",
      "portal.student.payments.column_type": "Type",
      "portal.student.payments.column_description": "Omschrijving",
      "portal.student.payments.column_duration": "Duur",
      "portal.student.payments.column_amount": "Bedrag",
      "portal.student.payments.items_title": "Lessen & Examens",
      "portal.student.payments.items_label": "Items",
      "portal.student.payments.type_lesson": "LES",
      "portal.student.payments.type_exam": "EXAMEN",
      "portal.teacher.student.scheduled_title": "Geplande lessen & examens",
      "portal.teacher.student.no_scheduled": "Geen geplande lessen of examens.",
      "portal.student.dashboard.no_payments": "Nog geen betalingen.",
      "portal.student.dashboard.billing_history": "Facturatiegeschiedenis",
      "portal.student.dashboard.my_exams_title": "Mijn examens",
      "portal.student.dashboard.no_exams": "Nog geen examens gepland.",
      "portal.student.exams.cancel_title": "Examen annuleren",
      "portal.student.exams.cancel_confirm": "Weet je zeker dat je dit examen wilt annuleren?",
      "portal.student.exams.cancel_button": "Examen annuleren",
      "portal.common.yes_cancel": "Ja, annuleren",
      "portal.student.dashboard.quick_tip_title": "Snelle tip",
      "portal.student.dashboard.tip_label": "Tip",
      "portal.student.dashboard.default_tip": "Check altijd je spiegels voordat je van rijstrook wisselt!",
      "portal.student.dashboard.resources_title": "Hulpmiddelen",
      "portal.student.dashboard.theory_material": "Theorie materiaal",
      "portal.student.dashboard.practice_exams": "Oefenexamens",
      "portal.student.dashboard.help_center": "Helpcentrum",

      "portal.exams.subtitle": "Je geplande en vorige examens",
      "portal.exams.refresh": "Vernieuwen",
      "portal.exams.create": "Examen inplannen",
      "portal.exams.management": "Examenbeheer",
      "portal.exams.upcoming": "Aankomende examens",
      "portal.exams.history_title": "Examengeschiedenis",
      "portal.exams.none_past": "Geen eerdere examens geregistreerd.",
      "portal.exams.schedule_new": "Nieuw examen inplannen",
      "portal.exams.date_time": "Datum & Tijd",
      "portal.exams.location": "Locatie / Plaats",
      "portal.exams.location_placeholder": "bijv. CBR Amsterdam",
      "portal.exams.assign_student": "Toewijzen aan leerling",
      "portal.exams.select_student_optional": "Selecteer een leerling (optioneel)",
      "portal.exams.creating": "Aanmaken...",
      "portal.exams.error_create": "Aanmaken van examen mislukt",
      "portal.exams.unassigned": "",
      "portal.exams.detail_title": "Examendetails",
      "portal.exams.back_to_list": "Terug naar examens",
      "portal.exams.not_found": "Examen niet gevonden of niet geautoriseerd.",
      "portal.exams.loading_details": "Examendetails laden...",
      "portal.exams.no_location": "Geen locatie ingesteld",
      "portal.exams.result": "Resultaat",
      "portal.exams.passed": "Geslaagd",
      "portal.exams.failed": "Gezakt",
      "portal.exams.pending": "In afwachting",
      "portal.exams.notes_title": "Opmerkingen van examinator",
      "portal.exams.no_notes": "Er zijn nog geen opmerkingen toegevoegd aan dit examen.",
      "portal.exams.add_note": "Nieuwe opmerking toevoegen",
      "portal.exams.max_notes": "Maximum aantal opmerkingen bereikt voor dit examen",
      "portal.exams.note_placeholder": "Schrijf hier je observatie...",
      "portal.exams.characters": "tekens",
      "portal.exams.note_empty": "Opmerking kan niet leeg zijn",
      "portal.exams.note_success": "Opmerking succesvol toegevoegd",
      "portal.exams.note_error": "Toevoegen van opmerking mislukt",
      "portal.exams.save_note": "Opmerking opslaan",
      "portal.exams.clear": "Wissen",
      "portal.exams.next_exam": "Volgend examen",
      "portal.exams.next_exam_sub": "Als je een examen hebt gepland, verschijnt deze hier",
      "portal.exams.no_upcoming": "Geen aankomend examen.",
      "portal.exams.history": "Geschiedenis",
      "portal.exams.history_sub": "Vorige examens",
      "portal.exams.none": "Nog geen examens.",
      "portal.exams.tap_details": "Tik voor details",
      "portal.exams.status.upcoming": "AANKOMEND",
      "portal.exams.status.completed": "VOLTOOID",
      "portal.exams.status.passed": "GESLAAGD",
      "portal.exams.status.failed": "GEZAKT",

      "portal.lessons.title": "Lessen",
      "portal.lessons.subtitle": "Bekijk je lessen en boek een nieuwe",
      "portal.lessons.tabs.booked": "Geboekt",
      "portal.lessons.tabs.available": "Beschikbaar",
      "portal.lessons.tabs.past": "Verleden",
      "portal.lessons.loading": "Lessen laden…",
      "portal.lessons.none_upcoming": "Geen aankomende lessen gepland.",
      "portal.lessons.teacher": "Instructeur:",
      "portal.lessons.your_note": "Jouw notitie:",
      "portal.lessons.cancel": "Annuleren",
      "portal.lessons.cancelling": "Annuleren…",
      "portal.lessons.exam": "Examen:",

      // Profile (NL)
      "portal.profile.title": "Profiel",
      "portal.profile.subtitle": "Beheer je persoonlijke gegevens en voorkeuren",
      "portal.profile.personal_info": "Persoonlijke informatie",
      "portal.profile.first_name": "Voornaam",
      "portal.profile.last_name": "Achternaam",
      "portal.profile.email": "E-mail",
      "portal.profile.phone": "Telefoonnummer",
      "portal.profile.dob": "Geboortedatum",
      "portal.profile.emergency_contact": "Contactpersoon voor noodgevallen",
      "portal.profile.emergency_contact_placeholder": "Naam en telefoonnummer",
      "portal.profile.address": "Adres",
      "portal.profile.address_placeholder": "Straat, Stad, Postcode",
      "portal.profile.pickup_location": "Ophaallocatie",
      "portal.profile.preferred_teacher": "Voorkeursinstructeur",
      "portal.profile.assigned_teacher": "Jouw toegewezen instructeur",
      "portal.profile.learning_progress": "Leer voortgang",
      "portal.profile.student_since": "Leerling sinds",
      "portal.profile.account_status": "Accountstatus",
      "portal.profile.experience_years": "Jaren ervaring",
      "portal.profile.max_lessons": "Max lessen per leerling per dag",
      "portal.profile.specializations": "Specialisaties",
      "portal.profile.no_specializations": "Geen specialisaties ingesteld",
      "portal.profile.specializations_placeholder": "bijv. Theorie-instructeur, Praktijklessen, Snelweglessen",
      "portal.profile.no_licenses": "Geen licenties ingesteld",
      "portal.profile.account_stats": "Accountstatistieken",
      "portal.profile.member_since": "Lid sinds",
      "portal.profile.access_full": "Volledig",
      "portal.profile.access_level": "Toegangsniveau",
      "portal.profile.language": "Taal",
      "portal.profile.theme": "Thema",
      "portal.profile.save": "Opslaan",
      "portal.profile.saving": "Bezig met opslaan…",
      "portal.profile.saved": "Profiel succesvol bijgewerkt!",
      "portal.profile.error": "Opslaan mislukt",
      "portal.profile.theme_updated": "Thema bijgewerkt naar {{theme}}",

      // Lesson Detail (NL)
      "portal.lesson.detail.assignment_locked": "Leerlingtoewijzing is vergrendeld voor voltooide lessen",
      "portal.lesson.detail.assignment_disabled": "Toewijzing uitgeschakeld na voltooiing.",
      "portal.lesson.detail.location_title": "Straatnaam en huisnummer",
      "portal.lesson.detail.teacher_note": "Notitie van instructeur",
      "portal.lesson.detail.student_note": "Notitie van leerling",
      "portal.lesson.detail.save_hint": "Wijzigingen worden opgeslagen met de hoofdknop Opslaan.",
      "portal.lesson.detail.feedback_title": "Feedback",
      "portal.lesson.detail.feedback_subtitle": "Beoordeel de les of beoordeel de leerling (na voltooiing)",
      "portal.lesson.detail.rate_lesson": "Beoordeel je les",
      "portal.lesson.detail.comment_placeholder": "Optionele opmerking",
      "portal.lesson.detail.rating_error": "Selecteer een beoordeling tussen 1 en 5",
      "portal.lesson.detail.rating_success": "Bedankt voor je beoordeling!",
      "portal.lesson.detail.rating_failed": "Beoordeling indienen mislukt",
      "portal.lesson.detail.submit_rating": "Beoordeling indienen",
      "portal.lesson.detail.grade_student": "Beoordeel de leerling",
      "portal.lesson.detail.graded_message": "Je hebt een {{grade}}/10 gegeven",
      "portal.lesson.detail.select_grade_error": "Selecteer een cijfer tussen 0 en 10",
      "portal.lesson.detail.grade_success": "Leerling succesvol beoordeeld!",
      "portal.lesson.detail.grade_failed": "Cijfer indienen mislukt",
      "portal.lesson.detail.submit_grade": "Cijfer indienen",
      "portal.lesson.detail.cancel_booking": "Les boeking annuleren",
      "portal.lesson.detail.grade_selector": "Cijferkiezer",
      "portal.lesson.detail.star_rating": "Sterbeoordeling",
      "portal.lesson.detail.stars_label": "{{count}} sterren",
      "portal.lesson.detail.drawer_label": "Lesdetails",
      "portal.lesson.detail.teacher_label": "Instructeur: {{name}}",
      "portal.lesson.detail.student_label": "Leerling: {{name}}",
      "portal.lesson.detail.student_selector": "Leerling",
      "portal.lesson.detail.duration_label": "Duur: {{count}} minuten",
      "portal.lesson.detail.location_input_label": "Ophaallocatie",
      "portal.lesson.detail.location_label": "Ophaallocatie: {{name}}",
      "portal.lesson.detail.location_placeholder": "Ophaallocatie invoeren",
      "portal.lesson.detail.time_label": "Tijd",
      "portal.lesson.detail.date_label": "Datum",
      "portal.lesson.detail.type_selector": "Lesstype",
      "portal.lesson.detail.confirm_cancel_booking": "Weet je zeker dat je deze les wilt annuleren?",
      "portal.lesson.detail.cancel_success": "Les boeking geannuleerd",
      "portal.lesson.detail.cancel_failed": "Annuleren van les mislukt",
      "portal.lesson.detail.filming_consent": "Toestemming voor filmen",
      "portal.lesson.detail.consent_given": "Toestemming gegeven",
      "portal.lesson.detail.consent_not_given": "Geen toestemming gegeven",
      "portal.lesson.detail.video_url": "Lesvideo URL",
      "portal.lesson.detail.video_url_placeholder": "Voer video-URL in (YouTube, Vimeo, etc.)...",
      "portal.lesson.detail.view_video": "Bekijk lesvideo",
      "portal.lesson.detail.video_updated": "Video-URL succesvol bijgewerkt",
      "portal.lesson.detail.consent_updated": "Toestemming voor filmen succesvol bijgewerkt",
      "portal.lesson.detail.teacher_note_label": "Instructeursnotitie",
      "portal.lesson.detail.teacher_note_placeholder": "Instructeursnotitie",
      "portal.lesson.detail.student_note_label": "Leerlingnotitie",
      "portal.lesson.detail.student_note_placeholder": "Leerlingnotitie",
      "portal.lesson.detail.student_review_label": "Leerlingbeoordeling",
      "portal.lesson.detail.student_review_placeholder_student": "Hoe was je les?",
      "portal.lesson.detail.student_review_placeholder_other": "Nog geen beoordeling van de leerling.",
      "portal.lesson.detail.started_lock_message": "Deze les is al begonnen en kan niet opnieuw worden toegewezen of geannuleerd.",
      "portal.lesson.detail.past_assign_message": "Het toewijzen van een leerling is toegestaan voor administratieve doeleinden.",
      "portal.lesson.detail.error_completed_assignment": "Kan leerling niet wijzigen voor een voltooide les.",
      
      // Footer
      "footer.description": "Wij houden je graag op de hoogte over ontwikkelingen van UniversalDrive.",
      "footer.privacy": "Privacy Policy",
      "footer.cookies": "Cookie Policy",
      "footer.social_media": "🔗 Social Media:",
      "footer.contact_title": "📍 Contactgegevens",
      "footer.contact_description": "Autorijschool Universal, voor Amsterdam en omstreken",
      "footer.address": "Javastraat 112, 1094 HN Amsterdam",
      "footer.phone": "Tel: 06 16752832",
      "footer.email": "Email: info@universaldrive.nl",
      "footer.instagram": "Instagram: @universaldrive",
      "footer.facebook": "Facebook: UniversalDrive",
      "footer.phone_label": "Phone: +31 6 16752832",
      "footer.digid_title": "🔐 Machtig ons met DigiD",
      "footer.digid_description": "Klik hier om Universaldrive te machtigen met je DigiD.",
      "footer.digid_link": "CBR Machtigen",
      "footer.copyright": "© {{year}} DaaS. All rights reserved | Designed & Implemented by bigO Digital NL",
      
      // Tariff Modal
      "modal.title": "Pakket Aanvragen",
      "modal.selected_package": "Geselecteerd pakket:",
      "modal.includes": "Inclusief:",
      "modal.name_label": "Naam",
      "modal.phone_label": "Telefoon",
      "modal.name_placeholder": "Uw naam",
      "modal.phone_placeholder": "Uw telefoonnummer",
      "modal.cancel": "Annuleren",
      "modal.submit": "Versturen",
      "modal.loading": "Even geduld alstublieft...",
      "modal.success": "Bedankt voor je aanvraag {name}! Uw aanvraag is succesvol verzonden! Ons team neemt binnenkort contact met je op!",
      "modal.error": "Er is een fout opgetreden. Probeer het later opnieuw.",
      "modal.ok": "OK",
      "modal.name_error_min": "Naam moet minimaal 2 karakters bevatten",
      "modal.name_error_max": "Naam mag maximaal 25 karakters bevatten",
      "modal.phone_error": "Voer een geldig Nederlands telefoonnummer in",
      
      // WhatsApp Button
      "whatsapp.title": "Contact ons via WhatsApp",
      "whatsapp.message": "Hallo! Ik ben geïnteresseerd in rijlessen bij UniversalDrive.",

      // Meta
      "meta.title": "Home - Beste rijschool van Amsterdam",
      "meta.description": "Home - Beste rijschool van Amsterdam"
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.auto": "Car",
      "nav.tarieven": "Rates",
      "nav.theoriecursus": "Theory Course",
      "nav.contact": "Contact",
      "nav.english": "English",
      "nav.studentPortal": "Portal",
      "nav.dashboard": "Dashboard",
      "nav.exams": "Exams",
      "nav.available_exams": "Available Exams",
      "nav.lessons": "Lessons",
      "nav.students": "Students",
      "nav.teachers": "Teachers",
      "nav.payments": "Payments",
      "nav.agenda": "My Agenda",
      "nav.parameters": "Parameters",
      "nav.navigation": "Navigation",
      "nav.settings": "Settings",
      "nav.my_profile": "My Profile",
      "nav.logout": "Logout",
      "nav.switch_language": "Switch Language",
      "nav.profile": "Profile",
      "common.cancel": "Cancel",
      "portal.common.refresh": "Refresh",
      "portal.common.booked": "Booked",
      "portal.common.book": "Book",
      "portal.common.unassigned": "",
      "portal.common.free": "Free",
      "portal.common.house_number": "House Number",
      "portal.common.postcode": "Postcode",
      "portal.common.license_type": "License Type",
      "nav.book_lesson": "Book Lesson",
        "home.hero.top": "Digitize your entire driving school workflow",
        "home.hero.middle": "All-in-one platform for your driving school",
        "home.hero.bottom": "€1 / student / month",
        "home.features.booking": "Book Lessons",
        "home.features.exams": "Exams",
        "home.features.payments": "Payments",
        "home.hero.see_how": "See how",
        "home.title": "DriveSchool Portal",
        "home.subtitle": "All-in-one cloud platform for driving schools, teachers, and students.",
        "home.chip": "The platform is free and only €1/month per student!",
        "home.cta": "Start Your Journey",
        "home.ctaTitle": "Ready to accelerate your driving school?",
        "home.ctaDesc": "Sign up as a teacher or school, and unlock all portal features for free. Add students, manage lessons, and boost your business for just €1/month per student!",
        "home.ctaButton": "Register Now",
        "home.features.cbr": "CBR Certified",
        "home.features.scheduling": "Smart Scheduling",
        "home.stats.instructors": "Instructors",
        "home.stats.students": "Students",
        "home.stats.schools": "Schools",
          "home.how.title": "How It Works",
          "home.how.cta": "Explore",
          "home.how.lead": "Why DaaS?",
          "home.how.sub": "Digitise your entire driving school workflow in one place.",
        "home.how.cards.0.title": "Real-time Scheduling",
        "home.how.cards.0.desc": "Effortlessly manage lessons and availability with our intuitive system.",
        "home.how.cards.1.title": "Student Management",
        "home.how.cards.1.desc": "Track progress, ratings, and CBR data for all your students in one central hub.",
        "home.how.cards.2.title": "CBR Connectivity",
        "home.how.cards.2.desc": "Import exams and results directly for seamless administration.",
        "home.how.cards.3.title": "Financial Insights",
        "home.how.cards.3.desc": "Automated invoicing and real-time payment status for every student.",
        "home.student.title": "Free For Student",
        "home.student.lead": "",
        "home.student.desc": "Manage your lessons, track your progress, and communicate with your instructor easily. It's completely free for students.",
        "home.student.referral": "Refer your driving school or instructor to use DaaS and get a discount on your next driving class once they join!",
        "home.student.cta": "Join as a Student",
        "home.student.referral_reward": "Referral Reward",
        "home.benefits.tag": "Why DaaS?",
        "home.benefits.title": "The all-in-one driving school management system",
        "home.benefits.price": "€1/student per month.",
        "home.benefits.items.0.title": "Smart Scheduling",
        "home.benefits.items.0.desc": "Efficiently manage lesson slots and teacher availability.",
        "home.benefits.items.1.title": "Automated Invoicing",
        "home.benefits.items.1.desc": "Get paid faster with integrated billing and payment tracking.",
        "home.benefits.items.2.title": "CBR Connectivity",
        "home.benefits.items.2.desc": "Import exams and results directly into your workflow.",
        
        "home.register.welcome": "Great that you want to try DaaS!",
        "home.register.motivation": "Save time on administration, focus on teaching. Join 1000+ instructors revolutionizing their driving schools with DaaS!",
        
        "home.student.register.welcome": "Ready to hit the road?",
        "home.student.register.motivation": "Manage your lessons, track your progress and get your license faster. Join thousands of students tackling their driver training smarter!",
        "home.student.register.benefit1.title": "The best driving school",
        "home.student.register.benefit1.desc": "Easily find the best driving school that perfectly fits your needs and budget.",
        "home.student.register.benefit2.title": "Theory & Practice",
        "home.student.register.benefit2.desc": "Prepare optimally for your theory exams and track your progress in your lessons.",
        "home.student.register.benefit3.title": "Watch lessons back",
        "home.student.register.benefit3.desc": "Improve your driving skills by watching your lessons back and analyzing feedback.",
        "home.student.register.benefit4.title": "Easy Planning",
        "home.student.register.benefit4.desc": "Book and manage your driving lessons directly online whenever it suits you.",
        
        // Portal Registration (EN)
        "portal.register.title": "Driving School Registration",
        "portal.register.teacher_title": "Register as instructor",
        "portal.register.student_title": "Register as student",
        "portal.register.subtitle": "Join our community of instructors",
        "portal.register.first_name": "First Name",
        "portal.register.first_name_placeholder": "Your first name",
        "portal.register.last_name": "Last Name",
        "portal.register.last_name_placeholder": "Your last name",
        "portal.register.driving_school_name": "Driving School Name",
        "portal.register.driving_school_placeholder": "Name of your driving school",
        "portal.register.postcode": "Postcode",
        "portal.register.postcode_placeholder": "Your postcode",
        "portal.register.house_number": "House number",
        "portal.register.house_number_placeholder": "Your house number",
        "portal.register.license_type": "License Type",
        "portal.register.license_am": "Moped (AM)",
        "portal.register.license_a1": "Motorcycle light (A1)",
        "portal.register.license_a2": "Motorcycle medium (A2)",
        "portal.register.license_a": "Motorcycle heavy (A)",
        "portal.register.license_b_manual": "Car (B) - Manual",
        "portal.register.license_b_automatic": "Car (B) - Automatic",
        "portal.register.license_be": "Car with trailer (BE)",
        "portal.register.license_b_plus": "Car with heavy trailer (B+)",
        "portal.register.license_c1": "Truck light (C1)",
        "portal.register.license_c1e": "Truck light with trailer (C1E)",
        "portal.register.license_c": "Truck (C)",
        "portal.register.license_ce": "Truck with trailer (CE)",
        "portal.register.license_d1": "Bus light (D1)",
        "portal.register.license_d1e": "Bus light with trailer (D1E)",
        "portal.register.license_d": "Bus (D)",
        "portal.register.license_de": "Bus with trailer (DE)",
        "portal.register.license_t": "Tractor (T)",
        "portal.register.license_manual": "Manual",
        "portal.register.license_automatic": "Automatic",
        "portal.register.email": "Email Address",
        "portal.register.email_placeholder": "your@email.com",
        "portal.register.password": "Password",
        "portal.register.password_placeholder": "••••••••",
        "portal.register.submit": "Register Now",
        "portal.register.loading": "Creating Account...",
        "portal.register.success": "Registration successful! Please check your email to verify your account.",
        "portal.register.have_account": "Already have an account? Sign In",
        "portal.register.no_commitment": "Registration is without obligation. You are not committed to anything.",
        "portal.register.no_commitment_student": "Registration is without obligation.",
        "portal.register.switch_to_student": "Are you a student? Register here",
        "portal.register.switch_to_teacher": "Are you an instructor? Register here",
        "portal.register.student": "Student",
        "portal.register.teacher": "Teacher",
        "portal.register.administrator": "Administrator",
        "portal.register.select_license": "Select license type",
        "portal.register.interests": "What do you want to learn?",
        "portal.register.interests_placeholder": "Choose what you want to learn",
        "portal.register.interest_theory": "Theory",
        "portal.register.interest_practical": "Practical",
        "portal.register.interest_tips": "Tips",
        "home.student.register.title": "Join as a student",
        "home.student.register.subtitle": "Start your driving lessons today",
        
        // Portal Login (EN)
        "portal.login.username": "Email or Username",
        "portal.login.username_placeholder": "Your email or username",
        "portal.login.password": "Password",
        "portal.login.username_required": "Email or Username is required",
        "portal.login.password_required": "Password is required",
        "portal.login.submit": "Sign In",
        "portal.login.forgot_password": "Forgot password?",
        "portal.login.forgot_password_title": "Forgot your password?",
        "portal.login.forgot_password_subtitle": "Enter your username and email to receive a reset link.",
        "portal.login.email": "Email Address",
        "portal.login.send_reset_link": "Send reset link",
        "portal.login.back_to_login": "Back to login",
        "portal.login.hide_password": "Hide password",
        "portal.login.show_password": "Show password",
        "portal.login.forgot_password_success_default": "If an account exists for that username and email, we’ve sent password reset instructions.",
        "portal.common.sending": "Sending...",
      // Hero Section
      "hero.title": "Haven't started driving lessons yet?",
      "hero.highlight1": "High pass rate",
      "hero.highlight2": "Installment payments possible",
      "hero.highlight3": "Experienced driving instructors",
      
      // Introduction Section
      "intro.title": "Driving lessons in Amsterdam and surroundings",
      "intro.description": "Universaldrive is one of the better driving schools since 2002. Over the years, we have built a reliable and professional reputation among the many satisfied students. We will therefore ensure that you choose a suitable training program through a trial lesson and that after completing your training, you can participate in traffic as smoothly as possible, safely and independently.",
      "intro.button": "Schedule Trial Lesson",
      
      // Services Section
      "services.title": "Services",
      "services.autorijles.title": "Car Driving Lessons",
      "services.autorijles.description": "Skilled instructors guide you in a pleasant way towards your goal: getting your driver's license and above all learning to drive independently, safely and smoothly.",
      "services.autorijles.button": "More information",
      "services.expaten.title": "Expats",
      "services.expaten.description": "Welcome to the Netherlands! Haven't driven for a (long) time? Don't worry. With our refresher driving lessons we'll help you get back on the road quickly. Do you already have a foreign driver's license? In some cases you can exchange it for a Dutch driver's license. Send us a message.",
      "services.expaten.button": "Send a message",
      "services.theorie.title": "Theory",
      "services.theorie.description": "We advise you to start with theory immediately alongside your practical lessons. That is, after all, the basis with which you can assess and estimate situations in traffic.",
      "services.theorie.button": "Theory Course",
      
      // Technologies Section
      "technologies.title": "Driving lessons in Amsterdam and surroundings. Since 2002",
      "technologies.description": "Looking for the best driving school in Amsterdam and surroundings? Then you've come to the right place. Getting a car driver's license is perhaps the most desired goal among today's youth. For some it's important for work, for others for economic reasons, for others it opens up other paths.",
      "technologies.kpi.founded": "Founded",
      "technologies.kpi.years": "Years",
      "technologies.kpi.happy_customers": "Happy customers",
      "technologies.best_driving_school": "Best driving school in Amsterdam",
      
      // Tariffs
      "tariffs.title": "CAR Tariffs",
      "tariffs.manual.title": "CAR Tariffs (Manual)",
      "tariffs.automatic.title": "Automatic Tariffs",

      "portal.lessons.bulk_create.title": "Bulk Create Lessons",
      "portal.lessons.bulk_create.start_date": "Start Date & Time",
      "portal.lessons.bulk_create.end_date": "End Date & Time",
      "portal.lessons.bulk_create.interval": "Interval (hours)",
      "portal.lessons.bulk_create.duration": "Duration (minutes)",
      "portal.lessons.bulk_create.submit": "Create Lessons",
      "portal.lessons.bulk_create.success": "Bulk lessons created successfully!",
      "portal.lessons.create.success": "Lesson created successfully!",
      "portal.lessons.bulk_create.error": "Failed to create bulk lessons.",
      "portal.lessons.add_lesson": "Add Lesson",
      "portal.lessons.create.title": "Create New Lesson",
      "portal.lessons.create.date_time": "Date & Time",
      "portal.lessons.create.duration": "Duration (minutes)",
      "portal.lessons.create.type": "Lesson Type",
      "portal.lessons.create.location": "Location",
      "portal.lessons.create.submit": "Create Lesson",
      "portal.lessons.create.error": "Error creating lesson.",

      "portal.lessons.title": "Lessons",
      "portal.lessons.subtitle": "Review your lessons and book a new one",
      "portal.lessons.tabs.booked": "Booked",
      "portal.lessons.tabs.available": "Available",
      "portal.lessons.tabs.past": "Past",
      "portal.lessons.loading": "Loading lessons…",
      "portal.lessons.none_upcoming": "No upcoming lessons scheduled.",
      "portal.lessons.teacher": "Teacher:",
      "portal.lessons.your_note": "Your note:",
      "portal.lessons.cancel": "Cancel",
      "portal.lessons.cancelling": "Cancelling…",
      "portal.lessons.exam": "Exam:",

      // Profile (EN)
      "portal.profile.title": "Profile",
      "portal.profile.subtitle": "Manage your personal details and preferences",
      "portal.profile.personal_info": "Personal Information",
      "portal.profile.first_name": "First name",
      "portal.profile.last_name": "Last name",
      "portal.profile.email": "E-mail",
      "portal.profile.phone": "Phone",
      "portal.profile.dob": "Date of Birth",
      "portal.profile.emergency_contact": "Emergency Contact",
      "portal.profile.emergency_contact_placeholder": "Name and phone number",
      "portal.profile.address": "Address",
      "portal.profile.address_placeholder": "Street, City, Postal Code",
      "portal.profile.pickup_location": "Pickup location",
      "portal.profile.preferred_teacher": "Preferred instructor",
      "portal.profile.assigned_teacher": "Your Assigned Teacher",
      "portal.profile.learning_progress": "Learning Progress",
      "portal.profile.student_since": "Student Since",
      "portal.profile.account_status": "Account Status",
      "portal.profile.experience_years": "Years of Experience",
      "portal.profile.max_lessons": "Max lessons per student per day",
      "portal.profile.specializations": "Specializations",
      "portal.profile.no_specializations": "No specializations set",
      "portal.profile.specializations_placeholder": "e.g., Theory Instructor, Practical Driving, Highway Lessons",
      "portal.profile.no_licenses": "No licenses set",
      "portal.profile.account_stats": "Account Statistics",
      "portal.profile.member_since": "Member Since",
      "portal.profile.access_full": "Full",
      "portal.profile.access_level": "Access Level",
      "portal.profile.language": "Language",
      "portal.profile.theme": "Theme",
      "portal.profile.save": "Save",
      "portal.profile.saving": "Saving…",
      "portal.profile.saved": "Profile updated successfully!",
      "portal.profile.error": "Save failed",
      "portal.profile.theme_updated": "Theme updated to {{theme}}",

      // Lesson Detail (EN)
      "portal.lesson.detail.assignment_locked": "Student assignment is locked for completed lessons",
      "portal.lesson.detail.assignment_disabled": "Assignment disabled after completion.",
      "portal.lesson.detail.location_title": "Street name and house number",
      "portal.lesson.detail.teacher_note": "Teacher note",
      "portal.lesson.detail.student_note": "Student's note",
      "portal.lesson.detail.save_hint": "Changes will be saved with the main Save button.",
      "portal.lesson.detail.feedback_title": "Feedback",
      "portal.lesson.detail.feedback_subtitle": "Rate the lesson or grade the student (after completion)",
      "portal.lesson.detail.rate_lesson": "Rate your lesson",
      "portal.lesson.detail.comment_placeholder": "Optional comment",
      "portal.lesson.detail.rating_error": "Please select a rating between 1 and 5",
      "portal.lesson.detail.rating_success": "Thanks for your rating!",
      "portal.lesson.detail.rating_failed": "Failed to submit rating",
      "portal.lesson.detail.submit_rating": "Submit rating",
      "portal.lesson.detail.grade_student": "Grade the student",
      "portal.lesson.detail.graded_message": "You graded {{grade}}/10",
      "portal.lesson.detail.select_grade_error": "Please select a grade between 0 and 10",
      "portal.lesson.detail.grade_success": "Student graded successfully!",
      "portal.lesson.detail.grade_failed": "Failed to submit grade",
      "portal.lesson.detail.submit_grade": "Submit grade",
      "portal.lesson.detail.cancel_booking": "Cancel booking",
      "portal.lesson.detail.grade_selector": "Grade selector",
      "portal.lesson.detail.star_rating": "Star rating",
      "portal.lesson.detail.stars_label": "{{count}} star",
      "portal.lesson.detail.drawer_label": "Lesson details",
      "portal.lesson.detail.teacher_label": "Teacher: {{name}}",
      "portal.lesson.detail.student_label": "Student: {{name}}",
      "portal.lesson.detail.student_selector": "Student",
      "portal.lesson.detail.duration_label": "Duration: {{count}} minutes",
      "portal.lesson.detail.location_input_label": "Pick-up",
      "portal.lesson.detail.location_label": "Pick-up: {{name}}",
      "portal.lesson.detail.location_placeholder": "Enter pick-up location",
      "portal.lesson.detail.time_label": "Time",
      "portal.lesson.detail.date_label": "Date",
      "portal.lesson.detail.type_selector": "Lesson type",
      "portal.lesson.detail.confirm_cancel_booking": "Are you sure you want to cancel this lesson?",
      "portal.lesson.detail.cancel_success": "Lesson booking cancelled",
      "portal.lesson.detail.cancel_failed": "Failed to cancel lesson",
      "portal.lesson.detail.filming_consent": "Filming Consent",
      "portal.lesson.detail.consent_given": "Consent Given",
      "portal.lesson.detail.consent_not_given": "Consent Not Given",
      "portal.lesson.detail.video_url": "Lesson Video URL",
      "portal.lesson.detail.video_url_placeholder": "Enter video URL (YouTube, Vimeo, etc.)...",
      "portal.lesson.detail.view_video": "View Lesson Video",
      "portal.lesson.detail.video_updated": "Video URL updated successfully",
      "portal.lesson.detail.consent_updated": "Filming consent updated successfully",
      "portal.lesson.detail.teacher_note_label": "Teacher Note",
      "portal.lesson.detail.teacher_note_placeholder": "Teacher's note",
      "portal.lesson.detail.student_note_label": "Student Note",
      "portal.lesson.detail.student_note_placeholder": "Student's note",
      "portal.lesson.detail.student_review_label": "Student Review",
      "portal.lesson.detail.student_review_placeholder_student": "How was your lesson?",
      "portal.lesson.detail.student_review_placeholder_other": "No review from student yet.",
      "portal.lesson.detail.started_lock_message": "This lesson has already started and can't be reassigned or canceled.",
      "portal.lesson.detail.past_assign_message": "Assigning a student is allowed for recordkeeping.",
      "portal.lesson.detail.error_completed_assignment": "Cannot change student for a completed lesson.",

      "portal.common.list": "List",
      "tariffs.benefits.high_pass_rate": "High passing rate",
      "tariffs.benefits.installment_payment": "Installment payment is possible",
      "tariffs.benefits.experienced_instructors": "Experienced driving instructors",
      
      "tariffs.packages.40_lessons": "40 driving lessons",
      "tariffs.packages.30_lessons": "30 driving lessons",
      "tariffs.packages.20_lessons": "20 driving lessons",
      "tariffs.packages.15_lessons": "15 driving lessons",
      "tariffs.packages.10_lessons": "10 driving lessons",
      "tariffs.packages.5_lessons": "5 driving lessons",
      "tariffs.packages.60_minutes": "60 minutes",
      "tariffs.packages.flexible": "Flexible",
      "tariffs.packages.cbr_exam": "CBR exam",
      "tariffs.packages.choose": "Choose",
      "tariffs.packages.you_decide": "You decide",
      "tariffs.packages.retake_package": "Retake Package",
      
      "tariffs.individual.title": "CAR INDIVIDUAL PRICES",
      "tariffs.individual.lesson": "Lesson",
      "tariffs.individual.price": "Price",
      "tariffs.individual.exam": "Exam",
      "tariffs.individual.trial_lesson": "Trial lesson",
      "tariffs.individual.free": "Free",
      "tariffs.individual.lesson_60": "Driving lesson 60 minutes",
      "tariffs.individual.lesson_90": "Driving lesson 90 minutes",
      "tariffs.individual.lesson_120": "Driving lesson 120 minutes",
      "tariffs.individual.ttt_exam": "T.T.T. intermediate test CBR",
      "tariffs.individual.cbr_exam": "CBR exam",
      "tariffs.individual.anxiety_exam": "Test anxiety exam",
      "tariffs.individual.bnor_exam": "BNOR exam",
      
      // Auto Page
      "auto.hero.title": "Don't you also want to be able to drive yourself?",
      "auto.hero.button": "Schedule Trial Lesson",
      "auto.benefits.high_pass": "High passing rate",
      "auto.benefits.installment": "Installment payment is possible",
      "auto.benefits.experienced": "Experienced driving instructors",
      "auto.details.title": "Getting started with your driver's license",
      "auto.details.intro": "Are you looking for a professional driving school in Amsterdam?",
      "auto.details.description": "Follow your first driving lesson (trial lesson) with us for free! Driving school Universaldrive provides driving lessons in Amsterdam. At Universaldrive, skilled instructors guide you in a pleasant way towards your goal: getting your driver's license and above all learning to drive independently, safely and smoothly.",
      "auto.details.more_text": "A personal plan is drawn up after the first trial lesson. Your possibilities and specific wishes are taken into account. We can then immediately make an estimate of the required number of lessons.\n\nYou get driving lessons in an excellent car with a permanent instructor. If desired, we pick you up from home and you will also be taken home again by the next student. This way you drive in various traffic areas and you also learn extra from each other.\n\nOf course we will also practice in the exam area to familiarize you with the situations you may encounter during the exam.",
      "auto.details.read_more": "Read more",
      "auto.details.read_less": "Read less",
      "auto.packages.title": "Choose your package!",
      "auto.packages.pro_max": "PRO MAX",
      "auto.packages.pro": "PRO",
      "auto.packages.premium": "PREMIUM",
      "auto.packages.lessons_40": "40 hours driving lessons",
      "auto.packages.lessons_30": "30 hours driving lessons",
      "auto.packages.lessons_20": "20 hours driving lessons",
      "auto.packages.cbr_exam": "CBR Exam included",
      "auto.packages.trial_button": "Trial lesson",
      "auto.callback.title": "Call me back",
      "auto.callback.name": "Name",
      "auto.callback.phone": "Phone",
      "auto.callback.submit": "Send",
      "auto.callback.auto": "Manual",
      "auto.callback.motor": "Automatic",
      "auto.callback.taxi": "Taxi",
      "auto.callback.theory": "Theory course",
      
      // Reviews Section
      "reviews.title": "Reviews",
      "reviews.description": "See what our students think of us.",
      "reviews.google": "Google Reviews",
      "reviews.facebook": "Facebook Reviews",
      
      // Demo Lesson Form
      "demo.title": "Schedule a Trial Lesson Now",
      "demo.name": "Name",
      "demo.phone": "Phone",
      "demo.email": "E-mail",
      "demo.service": "Service",
      "demo.service_auto_manual": "Car (B) Manual",
      "demo.service_auto_automatic": "Car (B) Automatic",
      "demo.service_theory": "Theory Course",
      "demo.submit": "Send",
      "demo.error": "Please fill in all required fields correctly.",
      "demo.success": "Your request has been sent successfully! Our team will contact you soon!",
      "demo.error_general": "Something went wrong. Please try again.",
      
      // Footer
      "footer.description": "We would like to keep you informed about developments at UniversalDrive.",
      "footer.privacy": "Privacy Policy",
      "footer.cookies": "Cookie Policy",
      "footer.social_media": "🔗 Social Media:",
      "footer.contact_title": "📍 Contact Information",
      "footer.contact_description": "Universal Driving School, for Amsterdam and surroundings",
      "footer.address": "Javastraat 112, 1094 HN Amsterdam",
      "footer.phone": "Tel: 06 16752832",
      "footer.email": "Email: info@universaldrive.nl",
      "footer.instagram": "Instagram: @universaldrive",
      "footer.facebook": "Facebook: UniversalDrive",
      "footer.phone_label": "Phone: +31 6 16752832",
      "footer.digid_title": "🔐 Authorize us with DigiD",
      "footer.digid_description": "Click here to authorize Universaldrive with your DigiD.",
      "footer.digid_link": "CBR Authorization",
        "footer.copyright": "© {{year}} DaaS. All rights reserved | Designed & Implemented by bigO Digital NL",
      // Tariff Modal
      "modal.title": "Request Package",
      "modal.selected_package": "Selected package:",
      "modal.includes": "Includes:",
      "modal.name_label": "Name",
      "modal.phone_label": "Phone",
      "modal.name_placeholder": "Your name",
      "modal.phone_placeholder": "Your phone number",
      "modal.cancel": "Cancel",
      "modal.submit": "Send",
      "modal.loading": "Please wait...",
      "modal.success": "Thank you for your request {name}! Your request has been sent successfully! Our team will contact you soon!",
      "modal.error": "An error occurred. Please try again later.",
      "modal.ok": "OK",
      "modal.name_error_min": "Name must contain at least 2 characters",
      "modal.name_error_max": "Name may contain at most 25 characters",
      "modal.phone_error": "Enter a valid Dutch phone number",
      
      // WhatsApp Button
      "whatsapp.title": "Contact us via WhatsApp",
      "whatsapp.message": "Hello! I am interested in driving lessons at UniversalDrive.",

      // Meta
      "meta.title": "Home - Best driving school in Amsterdam",
      "meta.description": "Home - Best driving school in Amsterdam",

      // Common (EN)
      "portal.common.loading": "Loading…",
      "portal.common.confirm": "Confirm",
      "portal.common.cancel": "Cancel",
      "portal.common.back": "Back",
      "portal.common.edit_profile": "Edit Profile",
      "portal.common.save_changes": "Save Changes",
      "portal.common.creating": "Creating…",
      "portal.common.view_all": "View All",
      "portal.common.details": "Details",
      "portal.common.tbd": "TBD",
      "portal.common.error": "Error",
      "portal.common.success": "Success",
      "portal.common.ok": "OK",
      "portal.common.not_authorized": "Not authorized",
      "portal.common.unnamed": "Unnamed",
      "portal.common.active": "Active",
      "portal.common.inactive": "Inactive",
      "portal.common.not_set": "Not Set",
      "portal.common.submitting": "Submitting…",
      "portal.common.cancelling": "Cancelling…",
      "portal.common.and_more": "and {{count}} more…",
      "portal.common.reviews": "reviews",
      "portal.common.close": "Close",
      "portal.common.edit": "Edit",
      "portal.common.no_changes": "No changes to save",
      "portal.common.edit_to_change": "Edit to add or change",
      "portal.common.discard": "Discard",
      "portal.common.discard_changes": "Discard changes",

      "portal.admin.students.title": "All Students",
      "portal.admin.students.add_button": "Add Student",
      "portal.admin.students.loading": "Loading students...",
      "portal.admin.students.empty": "No students found.",
      "portal.admin.students.add_modal_title": "Add New Student",
      "portal.admin.students.first_name_placeholder": "Student first name",
      "portal.admin.students.last_name_placeholder": "Student last name",
      "portal.admin.students.email_placeholder": "student@example.com",
      "portal.admin.students.create_button": "Create Student",
      "portal.admin.students.assign_teacher": "Assign Teacher (optional)",
      "portal.admin.students.select_teacher": "Select teacher",
      "portal.admin.students.select_type": "Select Type",
      "portal.admin.students.not_assigned": "Not Assigned",
      "portal.admin.students.assigned_teacher": "Assigned Teacher",
      "portal.admin.students.lessons_today": "Lessons Today",
      "portal.admin.students.today_booked": "Today Booked",
      "portal.admin.students.completed_lessons": "Completed Lessons",
      "portal.admin.students.exam_sessions": "Exam Sessions",
      "portal.admin.students.deactivate_button": "Deactivate Student Account",
      "portal.admin.teachers.title": "All Teachers",
      "portal.admin.teachers.add_button": "Add Teacher",
      "portal.admin.teachers.add_modal_title": "Add New Teacher",
      "portal.admin.teachers.first_name_placeholder": "Teacher first name",
      "portal.admin.teachers.last_name_placeholder": "Teacher last name",
      "portal.admin.teachers.email_placeholder": "teacher@example.com",
      "portal.admin.teachers.create_button": "Create Teacher",
      "portal.admin.teachers.loading": "Loading teachers...",
      "portal.admin.teachers.empty": "No teachers found.",
      "portal.admin.teachers.lessons_today": "Lessons Today",
      "portal.admin.teachers.today_booked": "Today Booked",
      "portal.admin.teachers.completed_lessons": "Completed Lessons",
      "portal.admin.teachers.exam_sessions": "Exam Sessions",
      "portal.admin.teachers.deactivate_button": "Deactivate Teacher Account",

      "portal.teacher.dashboard.welcome": "Welcome back, {{name}}!",
      "portal.teacher.dashboard.subtitle": "Here's what's happening with your students today.",
      "portal.teacher.dashboard.upcoming_lessons_stat": "Upcoming Lessons",
      "portal.teacher.dashboard.active_students_stat": "Active Students",
      "portal.teacher.dashboard.avg_rating_stat": "Avg. Rating",
      "portal.teacher.dashboard.upcoming_lessons_title": "Upcoming Lessons",
      "portal.teacher.dashboard.upcoming_exams_title": "Upcoming Exams",
      "portal.teacher.dashboard.passed_exams_title": "Passed Exams",
      "portal.teacher.dashboard.pending_payments_title": "Pending Payments",
      "portal.teacher.dashboard.payments_verified": "All payments verified!",
      "portal.teacher.dashboard.payment_pending": "Pending",
      "portal.teacher.dashboard.manage_payments": "Manage Payments",
      "portal.teacher.dashboard.quick_actions": "Quick Actions",
      "portal.teacher.dashboard.my_students": "My Students",
      "portal.teacher.dashboard.add_student_hint": "A temporary password and verification email will be sent to the student.",
      "portal.teacher.students.title": "My Students",
      "portal.teacher.students.search_placeholder": "Search students...",
      "portal.teacher.students.loading": "Loading students...",
      "portal.teacher.students.none_found": "No students found",
      "portal.teacher.students.error_loading": "Failed to load students",

      "portal.teacher.payments.title_outstanding": "Outstanding Payments",
      "portal.teacher.payments.title_history": "Payment History",
      "portal.teacher.payments.loading_outstanding": "Loading…",
      "portal.teacher.payments.loading_history": "Loading payments…",
      "portal.teacher.payments.no_outstanding": "No outstanding payments.",
      "portal.teacher.payments.no_history": "No payments to show.",
      "portal.teacher.payments.error_load": "Failed to load payments",
      "portal.teacher.payments.error_send_bill": "Failed to send bill",
      "portal.teacher.payments.success_send_bill": "Bill sent successfully",
      "portal.teacher.payments.last_update": "Last update",
      "portal.teacher.payments.sending": "Sending...",
      "portal.teacher.payments.send_bill": "Send Bill",
      "portal.teacher.payments.student_fallback": "Student",

      "portal.student.dashboard.welcome": "Hello, {{name}}!",
      "portal.student.dashboard.subtitle": "Track your progress and book your next driving lesson.",
      "portal.student.dashboard.balance_stat": "Balance",
      "portal.student.dashboard.next_lesson_label": "Next Lesson",
      "portal.student.dashboard.next_lesson_at": "at",
      "portal.student.dashboard.minutes_short": "min",
      "portal.student.dashboard.meeting_point": "Meeting point",
      "portal.student.dashboard.available_lessons_title": "",
      "portal.student.dashboard.see_more": "See more",
      "portal.student.dashboard.no_available_lessons": "No lessons available right now.",
      "portal.student.dashboard.teacher_feedback_title": "Teacher's Feedback",
      "portal.student.dashboard.no_feedback": "No feedback yet. Keep going!",
      "portal.student.dashboard.recent_payments_title": "Recent Payments",
      "portal.student.payments.column_student": "Student",
      "portal.student.payments.column_type": "Type",
      "portal.student.payments.column_description": "Description",
      "portal.student.payments.column_duration": "Duration",
      "portal.student.payments.column_amount": "Amount",
      "portal.student.payments.items_title": "Lessons & Exams",
      "portal.student.payments.items_label": "Items",
      "portal.student.payments.type_lesson": "LESSON",
      "portal.student.payments.type_exam": "EXAM",
      "portal.student.dashboard.no_payments": "No payments yet.",
      "portal.student.dashboard.billing_history": "Billing History",
      "portal.student.dashboard.my_exams_title": "My Exams",
      "portal.student.dashboard.no_exams": "No exams scheduled yet.",
      "portal.student.exams.cancel_title": "Cancel Exam",
      "portal.student.exams.cancel_confirm": "Are you sure you want to cancel this exam?",
      "portal.student.exams.cancel_button": "Cancel Exam",
      "portal.common.yes_cancel": "Yes, Cancel",
      "portal.student.dashboard.quick_tip_title": "Quick Tip",
      "portal.student.dashboard.tip_label": "Tip",
      "portal.student.dashboard.default_tip": "Always check your mirrors before changing lanes!",
      "portal.student.dashboard.resources_title": "Resources",
      "portal.student.dashboard.theory_material": "Theory Material",
      "portal.student.dashboard.practice_exams": "Practice Exams",
      "portal.student.dashboard.help_center": "Help Center",

      "portal.exams.subtitle": "Your planned and past exams",
      "portal.exams.refresh": "Refresh",
      "portal.exams.create": "Schedule Exam",
      "portal.exams.management": "Exams Management",
      "portal.exams.upcoming": "Upcoming Exams",
      "portal.exams.history_title": "Exam History",
      "portal.exams.none_past": "No past exams recorded.",
      "portal.exams.schedule_new": "Schedule New Exam",
      "portal.exams.date_time": "Date & Time",
      "portal.exams.location": "Location / Place",
      "portal.exams.location_placeholder": "e.g. CBR Amsterdam",
      "portal.exams.assign_student": "Assign to Student",
      "portal.exams.select_student_optional": "Select a student (optional)",
      "portal.exams.creating": "Creating...",
      "portal.exams.error_create": "Failed to create exam",
      "portal.exams.unassigned": "",
      "portal.exams.detail_title": "Exam Details",
      "portal.exams.back_to_list": "Back to Exams",
      "portal.exams.not_found": "Exam not found or not authorized.",
      "portal.exams.loading_details": "Loading exam details...",
      "portal.exams.no_location": "No location set",
      "portal.exams.result": "Result",
      "portal.exams.passed": "Passed",
      "portal.exams.failed": "Failed",
      "portal.exams.pending": "Pending",
      "portal.exams.notes_title": "Examiner Notes",
      "portal.exams.no_notes": "No notes have been added to this exam yet.",
      "portal.exams.add_note": "Add New Note",
      "portal.exams.max_notes": "Maximum notes reached for this exam",
      "portal.exams.note_placeholder": "Write your observation here...",
      "portal.exams.characters": "characters",
      "portal.exams.note_empty": "Note cannot be empty",
      "portal.exams.note_success": "Note added successfully",
      "portal.exams.note_error": "Failed to add note",
      "portal.exams.save_note": "Save Note",
      "portal.exams.clear": "Clear",
      "portal.exams.next_exam": "Next Exam",
      "portal.exams.next_exam_sub": "If you have a booked exam coming up, it appears here",
      "portal.exams.no_upcoming": "No upcoming exam.",
      "portal.exams.history": "History",
      "portal.exams.history_sub": "Past exams",
      "portal.exams.none": "No exams yet.",
      "portal.exams.tap_details": "Tap for details",
      "portal.exams.status.upcoming": "UPCOMING",
      "portal.exams.status.completed": "COMPLETED",
      "portal.exams.status.passed": "PASSED",
      "portal.exams.status.failed": "FAILED"
    }
  },
  tr: {
    translation: {
      // Navigation
      "nav.home": "Anasayfa",
      "nav.auto": "Araba",
      "nav.tarieven": "Ücretler",
      "nav.theoriecursus": "Teori Kursu",
      "nav.contact": "İletişim",
      "nav.english": "İngilizce",
      "nav.studentPortal": "Portal",
      "nav.dashboard": "Panel",
      "nav.exams": "Sınavlar",
      "nav.available_exams": "Mevcut Sınavlar",
      "nav.lessons": "Dersler",
      "nav.students": "Öğrenciler",
      "nav.teachers": "Eğitmenler",
      "nav.payments": "Ödemeler",
      "nav.agenda": "Ajandam",
      "nav.parameters": "Parametreler",
      "nav.navigation": "Navigasyon",
      "nav.settings": "Ayarlar",
      "nav.my_profile": "Profilim",
      "nav.logout": "Çıkış Yap",
      "nav.switch_language": "Dili Değiştir",
      "nav.profile": "Profil",
      "common.cancel": "İptal",
      "portal.common.refresh": "Yenile",
      "portal.common.booked": "Dolu",
      "portal.common.book": "Kitap",
      "portal.common.unassigned": "",
      "portal.common.free": "Boş",
      "portal.common.house_number": "Kapı Numarası",
      "portal.common.postcode": "Posta Kodu",
      "portal.common.license_type": "Ehliyet Türü",
      "portal.register.license_am": "Motorlu Bisiklet (AM)",
      "portal.register.license_a1": "Hafif Motosiklet (A1)",
      "portal.register.license_a2": "Orta Sınıf Motosiklet (A2)",
      "portal.register.license_a": "Ağır Motosiklet (A)",
      "portal.register.license_b_manual": "Otomobil (B) - Manuel",
      "portal.register.license_b_automatic": "Otomobil (B) - Otomatik",
      "portal.register.license_be": "Römorklu Otomobil (BE)",
      "portal.register.license_b_plus": "Ağır Römorklu Otomobil (B+)",
      "portal.register.license_c1": "Hafif Kamyon (C1)",
      "portal.register.license_c1e": "Römorklu Hafif Kamyon (C1E)",
      "portal.register.license_c": "Kamyon (C)",
      "portal.register.license_ce": "Römorklu Kamyon (CE)",
      "portal.register.license_d1": "Hafif Otobüs (D1)",
      "portal.register.license_d1e": "Römorklu Hafif Otobüs (D1E)",
      "portal.register.license_d": "Otobüs (D)",
      "portal.register.license_de": "Römorklu Otobüs (DE)",
      "portal.register.license_t": "Traktör (T)",
      "portal.register.license_manual": "Manuel",
      "portal.register.license_automatic": "Otomatik",
      "nav.book_lesson": "Ders Ayarla",
      "home.hero.top": "Tüm sürücü kursu iş akışınızı dijitalleştirin",
      "home.hero.middle": "Sürücü kursu yönetimi için hepsi bir arada platform",
      "home.hero.bottom": "€1 / öğrenci / ay",
      "home.features.booking": "Ders Rezervasyonu",
      "home.features.exams": "Sınavlar",
      "home.features.payments": "Ödemeler",
      "home.hero.see_how": "Nasıl olduğunu görün",
      "home.title": "DriveSchool Portalı",
      "home.subtitle": "Sürücü kursları, eğitmenler ve öğrenciler için hepsi bir arada bulut platformu.",
      "home.chip": "Platform ücretsizdir ve öğrenci başına aylık sadece 1 €'dur!",
      "home.cta": "Yolculuğunuza Başlayın",
      "home.ctaTitle": "Sürücü kursunuzu hızlandırmaya hazır mısınız?",
      "home.ctaDesc": "Eğitmen veya okul olarak kaydolun ve tüm portal özelliklerini ücretsiz olarak açın. Öğrenci ekleyin, dersleri yönetin ve öğrenci başına aylık sadece 1 € karşılığında işinizi büyütün!",
      "home.ctaButton": "Şimdi Kaydolun",
      "home.benefits.tag": "Neden DaaS?",
      "home.benefits.title": "Hepsi bir arada sürücü kursu yönetim sistemi",
        "home.benefits.price": "Öğrenci başı €1/ay.",
      "home.benefits.items.0.title": "Akıllı Planlama",
      "home.benefits.items.0.desc": "Ders saatlerini ve eğitmen müsaitliğini etkili bir şekilde yönetin.",
      "home.benefits.items.1.title": "Otomatik Faturalama",
      "home.benefits.items.1.desc": "Entegre faturalama ve ödeme takibi ile daha hızlı ödeme alın.",
      "home.benefits.items.2.title": "CBR Bağlantısı",
      "home.benefits.items.2.desc": "Sınavları ve sonuçları doğrudan iş akışınıza aktarın.",
      
      "home.register.welcome": "DaaS'ı denemek istemeniz harika!",
      "home.register.motivation": "Yönetim işlerinde zaman kazanın, ders vermeye odaklanın. Sürücü kurslarını DaaS ile devrim yaratan 1000'den fazla eğitmene katılın!",
      
      "home.student.register.welcome": "Yola çıkmaya hazır mısın?",
      "home.student.register.motivation": "Derslerini yönet, ilerlemeni takip et ve ehliyetini daha hızlı al. Sürücü eğitimlerini daha akıllıca yürüten binlerce öğrenciye katıl!",
      "home.student.register.benefit1.title": "En iyi sürücü kursu",
      "home.student.register.benefit1.desc": "İhtiyaçlarınıza ve bütçenize tam olarak uyan en iyi sürücü kursunu kolayca bulun.",
      "home.student.register.benefit2.title": "Teori ve Pratik",
      "home.student.register.benefit2.desc": "Teorik sınavlarınıza en iyi şekilde hazırlanın ve derslerinizdeki ilerlemenizi takip edin.",
      "home.student.register.benefit3.title": "Dersleri tekrar izle",
      "home.student.register.benefit3.desc": "Derslerinizi tekrar izleyerek ve geri bildirimleri analiz ederek sürüş becerilerinizi geliştirin.",
      "home.student.register.benefit4.title": "Kolay Planlama",
      "home.student.register.benefit4.desc": "Direksiyon derslerinizi ne zaman isterseniz doğrudan çevrimiçi olarak planlayın ve yönetin.",
      
      // Portal Registration (TR)
      "portal.register.title": "Sürücü Kursu Kaydı",
      "portal.register.teacher_title": "Eğitmen olarak kaydolun",
      "portal.register.student_title": "Öğrenci olarak kaydolun",
      "portal.register.subtitle": "Eğitmen topluluğumuza katılın",
      "portal.register.first_name": "İsim",
      "portal.register.first_name_placeholder": "İsminiz",
      "portal.register.last_name": "Soyisim",
      "portal.register.last_name_placeholder": "Soyisminiz",
      "portal.register.driving_school_name": "Sürücü Kursu Adı",
      "portal.register.driving_school_placeholder": "Sürücü kursunuzun adı",
      "portal.register.postcode": "Posta Kodu",
      "portal.register.postcode_placeholder": "Posta kodunuz",
      "portal.register.house_number": "Kapı Numarası",
      "portal.register.house_number_placeholder": "Kapı numaranız",
      "portal.register.email": "E-posta Adresi",
      "portal.register.email_placeholder": "isminiz@eposta.com",
      "portal.register.password": "Şifre",
      "portal.register.password_placeholder": "••••••••",
      "portal.register.submit": "Şimdi Kaydolun",
      "portal.register.loading": "Hesap Oluşturuluyor...",
      "portal.register.success": "Kayıt başarılı! Hesabınızı doğrulamak için lütfen e-postanızı kontrol edin.",
      "portal.register.have_account": "Zaten hesabınız var mı? Giriş Yap",
      "portal.register.no_commitment": "Kayıt olmak ücretsizdir ve herhangi bir taahhüt gerektirmez.",
      "portal.register.no_commitment_student": "Kayıt olmak ücretsizdir.",
      "portal.register.switch_to_student": "Öğrenci misiniz? Buradan kaydolun",
      "portal.register.switch_to_teacher": "Eğitmen misiniz? Buradan kaydolun",
      "portal.register.student": "Öğrenci",
      "portal.register.teacher": "Eğitmen",
      "portal.register.administrator": "Yönetici",
      "portal.register.select_license": "Ehliyet türünü seçin",
      "portal.register.interests": "Ne öğrenmek istiyorsun?",
      "portal.register.interests_placeholder": "Öğrenmek istediğiniz şeyi seçin",
      "portal.register.interest_theory": "Teorik",
      "portal.register.interest_practical": "Pratik",
      "portal.register.interest_tips": "İpuçları",
      "home.student.register.title": "Öğrenci olarak katıl",
      "home.student.register.subtitle": "Direksiyon derslerinize bugün başlayın",
        
      // Portal Login (TR)
      "portal.login.username": "E-posta veya Kullanıcı Adı",
      "portal.login.username_placeholder": "E-postanız veya kullanıcı adınız",
      "portal.login.password": "Şifre",
      "portal.login.username_required": "E-posta veya kullanıcı adı gerekli",
      "portal.login.password_required": "Şifre gerekli",
      "portal.login.submit": "Giriş Yap",
      "portal.login.forgot_password": "Şifremi unuttum?",
      "portal.login.forgot_password_title": "Şifrenizi mi unuttunuz?",
      "portal.login.forgot_password_subtitle": "Bir sıfırlama bağlantısı almak için kullanıcı adınızı ve e-postanızı girin.",
      "portal.login.email": "E-posta Adresi",
      "portal.login.send_reset_link": "Sıfırlama bağlantısı gönder",
      "portal.login.back_to_login": "Giriş yapmaya geri dön",
      "portal.login.hide_password": "Şifreyi gizle",
      "portal.login.show_password": "Şifreyi göster",
      "portal.login.forgot_password_success_default": "Bu kullanıcı adı ve e-posta için bir hesap varsa, şifre sıfırlama talimatlarını gönderdik.",
      "portal.common.sending": "Gönderiliyor...",

      // How it works (TR)
      "home.how.title": "Nasıl Çalışır",
      "home.how.cta": "Keşfet",
      "home.how.lead": "Platformumuz verileri, planlamayı ve iletişimi birleştirir; böylece sürücü kursları daha hızlı, daha iyi ve daha akıllıca çalışabilir.",
      "home.how.cards.0.title": "Kolay Ders Rezervasyonu",
      "home.how.cards.0.desc": "Öğrenciler eğitmen müsaitliğini inceleyebilir ve çevrimiçi ders rezervasyonu yapabilir; otomatik takvim senkronizasyonu ve güncellemeler dahildir.",
      "home.how.cards.1.title": "Dersleri ve Öğrencileri Yönetin",
      "home.how.cards.1.desc": "Okullar ve eğitmenler öğrenci ekleyebilir/silebilir, planlama yapabilir, ilerlemeyi takip edebilir ve aylık detaylı raporlar alabilir.",
      "home.how.cards.2.title": "Güvenli, Güvenilir ve Sertifikalı",
      "home.how.cards.2.desc": "Tüm eğitmenler doğrulanmıştır ve öğrenci verileri güvenle korunur. Resmi CBR sınavları ve isteğe bağlı sınav kaygısı desteği ile entegredir.",
      "home.how.cards.3.title": "Şeffaf Fiyatlandırma",
      "home.how.cards.3.desc": "Okullar ve eğitmenler için net aylık ücretler, gizli maliyet yok. Öğrenciler sadece seçtikleri paketler veya tekli dersler için ödeme yaparlar.",
      "home.student.title": "Öğrenciler için ücretsiz",
      "home.student.lead": "",
      "home.student.desc": "Derslerinizi yönetin, ilerlemenizi takip edin ve eğitmeninizle kolayca iletişim kurun. Öğrenciler için tamamen ücretsizdir.",
      "home.student.referral": "Sürücü kursunuzu veya eğitmeninizi DaaS kullanmaya yönlendirin ve onlar katıldığında bir sonraki sürüş dersinizde indirim kazanın!",
      "home.student.referral_reward": "Referans Ödülü",
      "home.student.cta": "Öğrenci Olarak Katıl",
      
      // Hero Section (TR)
      "hero.title": "Henüz direksiyon derslerine başlamadınız mı?",
      "hero.highlight1": "Yüksek başarı oranı",
      "hero.highlight2": "Taksitli ödeme imkanı",
      "hero.highlight3": "Deneyimli sürüş eğitmenleri",

      // Introduction Section (TR)
      "intro.title": "Amsterdam ve çevresinde direksiyon dersleri",
      "intro.description": "Universaldrive, 2002'den beri en iyi sürücü kurslarından biridir. Yıllar içinde memnun öğrenciler arasında güvenilir ve profesyonel bir itibar kazandık. Bir deneme dersi ile size uygun eğitim programını seçmenizi ve eğitiminizi tamamladıktan sonra trafiğe mümkün olduğunca akıcı, güvenli ve bağımsız bir şekilde katılabilmenizi sağlıyoruz.",
      "intro.button": "Deneme Dersi Planla",

      // Services Section (TR)
      "services.title": "Hizmetler",
      "services.autorijles.title": "Araba Direksiyon Dersleri",
      "services.autorijles.description": "Uzman eğitmenler, hedefinize doğru keyifli bir şekilde rehberlik eder: ehliyetinizi almanız ve her şeyden önce bağımsız, güvenli ve akıcı bir şekilde araç kullanmayı öğrenmeniz.",
      "services.autorijles.button": "Daha fazla bilgi",
      "services.expaten.title": "Gurbetçiler",
      "services.expaten.description": "Hollanda'ya hoş geldiniz! (Uzun süredir) araç kullanmadınız mı? Endişelenmeyin. Tazeleme derslerimizle yollara hızla dönmenize yardımcı oluyoruz. Zaten yabancı ehliyetiniz mi var? Bazı durumlarda Hollanda ehliyeti ile değiştirebilirsiniz. Bize mesaj gönderin.",
      "services.expaten.button": "Mesaj gönder",
      "services.theorie.title": "Teori",
      "services.theorie.description": "Pratik derslerinizin yanında hemen teoriye de başlamanızı öneririz. Bu, trafikteki durumları değerlendirebileceğiniz ve tahmin edebileceğiniz temeldir.",
      "services.theorie.button": "Teori Kursu",

      // Technologies Section (TR)
      "technologies.title": "Amsterdam ve çevresinde direksiyon dersleri. 2002'den beri",
      "technologies.description": "Amsterdam ve çevresindeki en iyi sürücü kursunu mu arıyorsunuz? Doğru yerdesiniz. Ehliyet almak günümüz gençliğinin belki de en çok istediği hedeftir. Bazıları için iş için önemli, bazıları için ekonomik nedenlerle, bazıları için ise farklı yollar açar.",
      "technologies.kpi.founded": "Kuruluş",
      "technologies.kpi.years": "Yıllık deneyim",
      "technologies.kpi.happy_customers": "Mutlu müşteriler",
      "technologies.best_driving_school": "Amsterdam'ın en iyi sürücü kursu",

      // Tariffs (TR)
      "tariffs.title": "ARABA Ücretleri",
      "tariffs.manual.title": "ARABA Ücretleri (Manuel)",
      "tariffs.automatic.title": "Otomatik Vites Ücretleri",
      "tariffs.benefits.high_pass_rate": "Yüksek geçme oranı",
      "tariffs.benefits.installment_payment": "Taksitli ödeme mümkündür",
      "tariffs.benefits.experienced_instructors": "Deneyimli direksiyon eğitmenleri",

      "tariffs.packages.40_lessons": "40 direksiyon dersi",
      "tariffs.packages.30_lessons": "30 direksiyon dersi",
      "tariffs.packages.20_lessons": "20 direksiyon dersi",
      "tariffs.packages.15_lessons": "15 direksiyon dersi",
      "tariffs.packages.10_lessons": "10 direksiyon dersi",
      "tariffs.packages.5_lessons": "5 direksiyon dersi",
      "tariffs.packages.60_minutes": "60 dakika",
      "tariffs.packages.flexible": "Esnek",
      "tariffs.packages.cbr_exam": "CBR sınavı",
      "tariffs.packages.choose": "Seç",
      "tariffs.packages.you_decide": "Siz karar verin",
      "tariffs.packages.retake_package": "Sınav Tekrar Paketi",

      "tariffs.individual.title": "ARABA TEKLİ FİYATLAR",
      "tariffs.individual.lesson": "Ders",
      "tariffs.individual.price": "Fiyat",
      "tariffs.individual.exam": "Sınav",
      "tariffs.individual.trial_lesson": "Deneme dersi",
      "tariffs.individual.free": "Ücretsiz",
      "tariffs.individual.lesson_60": "Direksiyon dersi 60 dakika",
      "tariffs.individual.lesson_90": "Direksiyon dersi 90 dakika",
      "tariffs.individual.lesson_120": "Direksiyon dersi 120 dakika",
      "tariffs.individual.ttt_exam": "T.T.T. ara sınav CBR",
      "tariffs.individual.cbr_exam": "CBR sınavı",
      "tariffs.individual.anxiety_exam": "Sınav kaygısı sınavı",
      "tariffs.individual.bnor_exam": "BNOR sınavı",

      "portal.lessons.bulk_create.title": "Toplu Ders Oluştur",
      "portal.lessons.bulk_create.start_date": "Başlangıç Tarihi ve Saati",
      "portal.lessons.bulk_create.end_date": "Bitiş Tarihi ve Saati",
      "portal.lessons.bulk_create.interval": "Aralık (saat)",
      "portal.lessons.bulk_create.duration": "Süre (dakika)",
      "portal.lessons.bulk_create.submit": "Dersleri Oluştur",
      "portal.lessons.bulk_create.success": "Toplu dersler başarıyla oluşturuldu!",
      "portal.lessons.create.success": "Ders başarıyla oluşturuldu!",
      "portal.lessons.bulk_create.error": "Toplu ders oluşturma hatası.",
      "portal.lessons.add_lesson": "Ders Ekle",
      "portal.lessons.create.title": "Yeni Ders Oluştur",
      "portal.lessons.create.date_time": "Tarih ve Saat",
      "portal.lessons.create.duration": "Süre (dakika)",
      "portal.lessons.create.type": "Ders Tipi",
      "portal.lessons.create.location": "Konum",
      "portal.lessons.create.submit": "Ders Oluştur",
      "portal.lessons.create.error": "Ders oluşturma hatası.",

      "portal.lessons.title": "Dersler",
      "portal.lessons.subtitle": "Derslerinizi inceleyin ve yeni bir tane ayırtın",
      "portal.lessons.tabs.booked": "Rezerve",
      "portal.lessons.tabs.available": "Müsait",
      "portal.lessons.tabs.past": "Geçmiş",
      "portal.lessons.loading": "Dersler yükleniyor…",
      "portal.lessons.none_upcoming": "Planlanmış gelecek ders yok.",
      "portal.lessons.teacher": "Eğitmen:",
      "portal.lessons.your_note": "Notunuz:",
      "portal.lessons.cancel": "İptal Et",
      "portal.lessons.cancelling": "İptal ediliyor…",
      "portal.lessons.exam": "Sınav:",

      // Profile (TR)
      "portal.profile.title": "Profil",
      "portal.profile.subtitle": "Kişisel bilgilerinizi ve tercihlerinizi yönetin",
      "portal.profile.personal_info": "Kişisel Bilgiler",
      "portal.profile.first_name": "İsim",
      "portal.profile.last_name": "Soyisim",
      "portal.profile.email": "E-posta",
      "portal.profile.phone": "Telefon",
      "portal.profile.dob": "Doğum Tarihi",
      "portal.profile.emergency_contact": "Acil Durum İletişimi",
      "portal.profile.emergency_contact_placeholder": "İsim ve telefon numarası",
      "portal.profile.address": "Adres",
      "portal.profile.address_placeholder": "Sokak, Şehir, Posta Kodu",
      "portal.profile.pickup_location": "Alınış yeri",
      "portal.profile.preferred_teacher": "Tercih edilen eğitmen",
      "portal.profile.assigned_teacher": "Atanmış eğitmeniniz",
      "portal.profile.learning_progress": "Öğrenme İlerlemesi",
      "portal.profile.student_since": "Şu tarihten beri öğrenci",
      "portal.profile.account_status": "Hesap Durumu",
      "portal.profile.experience_years": "Deneyim Yılı",
      "portal.profile.max_lessons": "Öğrenci başına günlük maksimum ders",
      "portal.profile.specializations": "Uzmanlık Alanları",
      "portal.profile.no_specializations": "Uzmanlık alanı belirtilmedi",
      "portal.profile.specializations_placeholder": "örn. Teori Eğitmeni, Uygulamalı Sürüş, Otoyol Dersleri",
      "portal.profile.no_licenses": "Henüz lisans ayarlanmamış",
      "portal.profile.account_stats": "Hesap İstatistikleri",
      "portal.profile.member_since": "Şu tarihten beri üye",
      "portal.profile.access_full": "Tam",
      "portal.profile.access_level": "Erişim Seviyesi",
      "portal.profile.language": "Dil",
      "portal.profile.theme": "Tema",
      "portal.profile.save": "Kaydet",
      "portal.profile.saving": "Kaydediliyor…",
      "portal.profile.saved": "Profil başarıyla güncellendi!",
      "portal.profile.error": "Kaydetme hatası",
      "portal.profile.theme_updated": "Tema {{theme}} olarak güncellendi",

      // Lesson Detail (TR)
      "portal.lesson.detail.assignment_locked": "Tamamlanan dersler için öğrenci ataması kilitlidir",
      "portal.lesson.detail.assignment_disabled": "Tamamlandıktan sonra atama devre dışı bırakılır.",
      "portal.lesson.detail.location_placeholder": "Sokak ve numara (örn. Damrak 1A)",
      "portal.lesson.detail.location_title": "Sokak adı ve kapı numarası",
      "portal.lesson.detail.teacher_note": "Eğitmen notu",
      "portal.lesson.detail.student_note": "Öğrenci notu",
      "portal.lesson.detail.save_hint": "Değişiklikler ana Kaydet düğmesiyle kaydedilecektir.",
      "portal.lesson.detail.feedback_title": "Geri Bildirim",
      "portal.lesson.detail.feedback_subtitle": "Dersi puanlayın veya öğrenciye not verin (tamamlandıktan sonra)",
      "portal.lesson.detail.rate_lesson": "Dersinizi puanlayın",
      "portal.lesson.detail.comment_placeholder": "İsteğe bağlı yorum",
      "portal.lesson.detail.rating_error": "Lütfen 1 ile 5 arasında bir puan seçin",
      "portal.lesson.detail.rating_success": "Puanınız için teşekkürler!",
      "portal.lesson.detail.rating_failed": "Puan gönderilemedi",
      "portal.lesson.detail.submit_rating": "Puanı gönder",
      "portal.lesson.detail.grade_student": "Öğrenciye not ver",
      "portal.lesson.detail.graded_message": "Notunuz: {{grade}}/10",
      "portal.lesson.detail.select_grade_error": "Lütfen 0 ile 10 arasında bir not seçin",
      "portal.lesson.detail.grade_success": "Öğrenci başarıyla notlandırıldı!",
      "portal.lesson.detail.grade_failed": "Not gönderilemedi",
      "portal.lesson.detail.submit_grade": "Notu gönder",
      "portal.lesson.detail.cancel_booking": "Ders rezervasyonunu iptal et",
      "portal.lesson.detail.grade_selector": "Not seçici",
      "portal.lesson.detail.star_rating": "Yıldız puanı",
      "portal.lesson.detail.stars_label": "{{count}} yıldız",
      "portal.lesson.detail.drawer_label": "Ders detayları",
      "portal.lesson.detail.teacher_label": "Eğitmen: {{name}}",
      "portal.lesson.detail.student_label": "Öğrenci: {{name}}",
      "portal.lesson.detail.student_selector": "Öğrenci seçici",
      "portal.lesson.detail.duration_label": "Süre: {{count}} dakika",
      "portal.lesson.detail.location_input_label": "Ders konumu",
      "portal.lesson.detail.location_label": "Konum: {{name}}",
      "portal.lesson.detail.type_selector": "Ders türü",
      "portal.lesson.detail.confirm_cancel_booking": "Bu dersi iptal etmek istediğinizden emin misiniz?",
      "portal.lesson.detail.cancel_success": "Ders rezervasyonu iptal edildi",
      "portal.lesson.detail.cancel_failed": "Ders iptal edilemedi",
      "portal.lesson.detail.started_lock_message": "Bu ders zaten başladı ve yeniden atanamaz veya iptal edilemez.",
      "portal.lesson.detail.past_assign_message": "Kayıt tutma amacıyla öğrenci atanmasına izin verilir.",
      "portal.lesson.detail.error_completed_assignment": "Tamamlanan bir ders için öğrenci değiştirilemez.",

      "portal.common.list": "Liste",
      "portal.common.loading": "Yükleniyor…",
      "portal.common.confirm": "Onayla",
      "portal.common.cancel": "İptal",
      "portal.common.back": "Geri",
      "portal.common.edit_profile": "Profili Düzenle",
      "portal.common.save_changes": "Değişiklikleri Kaydet",
      "portal.common.creating": "Oluşturuluyor…",
      "portal.common.view_all": "Hepsini Gör",
      "portal.common.details": "Detaylar",
      "portal.common.tbd": "Belli Değil",
      "portal.common.error": "Hata",
      "portal.common.success": "Başarılı",
      "portal.common.ok": "Tamam",
      "portal.common.not_authorized": "Yetkiniz yok",
      "portal.common.unnamed": "İsimsiz",
      "portal.common.active": "Aktif",
      "portal.common.inactive": "Pasif",
      "portal.common.not_set": "Ayarlanmadı",
      "portal.common.submitting": "Gönderiliyor…",
      "portal.common.cancelling": "İptal ediliyor…",
      "portal.common.and_more": "ve {{count}} tane daha…",
      "portal.common.reviews": "değerlendirme",
      "portal.common.close": "Kapat",
      "portal.common.edit": "Düzenle",
      "portal.common.no_changes": "Kaydedilecek değişiklik yok",
      "portal.common.edit_to_change": "Eklemek veya değiştirmek için düzenleyin",
      "portal.common.discard": "İptal",
      "portal.common.discard_changes": "Değişiklikleri iptal et",

      "portal.admin.students.title": "Tüm Öğrenciler",
      "portal.admin.students.add_button": "Öğrenci Ekle",
      "portal.admin.students.loading": "Öğrenciler yükleniyor...",
      "portal.admin.students.empty": "Öğrenci bulunamadı.",
      "portal.admin.students.add_modal_title": "Yeni Öğrenci Ekle",
      "portal.admin.students.first_name_placeholder": "Öğrenci adı",
      "portal.admin.students.last_name_placeholder": "Öğrenci soyadı",
      "portal.admin.students.email_placeholder": "ogrenci@ornek.com",
      "portal.admin.students.create_button": "Öğrenci Oluştur",
      "portal.admin.students.assign_teacher": "Eğitmen Ata (isteğe bağlı)",
      "portal.admin.students.select_teacher": "Eğitmen seçin",
      "portal.admin.students.select_type": "Tür Seçin",
      "portal.admin.students.not_assigned": "Atanmadı",
      "portal.admin.students.assigned_teacher": "Atanmış Eğitmen",
      "portal.admin.students.lessons_today": "Bugünkü Dersler",
      "portal.admin.students.today_booked": "Bugün Rezerve Edilen",
      "portal.admin.students.completed_lessons": "Tamamlanan Dersler",
      "portal.admin.students.exam_sessions": "Sınav Oturumları",
      "portal.admin.students.deactivate_button": "Öğrenci Hesabını Devre Dışı Bırak",
      "portal.admin.teachers.title": "Tüm Eğitmenler",
      "portal.admin.teachers.add_button": "Eğitmen Ekle",
      "portal.admin.teachers.add_modal_title": "Yeni Eğitmen Ekle",
      "portal.admin.teachers.first_name_placeholder": "Eğitmen adı",
      "portal.admin.teachers.last_name_placeholder": "Eğitmen soyadı",
      "portal.admin.teachers.email_placeholder": "egitmen@ornek.com",
      "portal.admin.teachers.create_button": "Eğitmen Oluştur",
      "portal.admin.teachers.loading": "Eğitmenler yükleniyor...",
      "portal.admin.teachers.empty": "Eğitmen bulunamadı.",
      "portal.admin.teachers.lessons_today": "Bugünkü Dersler",
      "portal.admin.teachers.today_booked": "Bugün Rezerve Edilen",
      "portal.admin.teachers.completed_lessons": "Tamamlanan Dersler",
      "portal.admin.teachers.exam_sessions": "Sınav Oturumları",
      "portal.admin.teachers.deactivate_button": "Eğitmen Hesabını Devre Dışı Bırak",

      "portal.teacher.dashboard.welcome": "Tekrar hoş geldin, {{name}}!",
      "portal.teacher.dashboard.subtitle": "Bugün öğrencilerinizle neler olup bittiğini buradan takip edebilirsiniz.",
      "portal.teacher.dashboard.upcoming_lessons_stat": "Gelecek Dersler",
      "portal.teacher.dashboard.active_students_stat": "Aktif Öğrenciler",
      "portal.teacher.dashboard.avg_rating_stat": "Ort. Puan",
      "portal.teacher.dashboard.upcoming_lessons_title": "Gelecek Dersler",
      "portal.teacher.dashboard.upcoming_exams_title": "Gelecek Sınavlar",
      "portal.teacher.dashboard.passed_exams_title": "Geçmiş Sınavlar",
      "portal.teacher.dashboard.pending_payments_title": "Bekleyen Ödemeler",
      "portal.teacher.dashboard.payments_verified": "Tüm ödemeler doğrulandı!",
      "portal.teacher.dashboard.payment_pending": "Bekliyor",
      "portal.teacher.dashboard.manage_payments": "Ödemeleri Yönet",
      "portal.teacher.dashboard.quick_actions": "Hızlı İşlemler",
      "portal.teacher.dashboard.my_students": "Öğrencilerim",
      "portal.teacher.dashboard.add_student_hint": "Öğrenciye geçici bir şifre ve doğrulama e-postası gönderilecektir.",
      "portal.teacher.students.title": "Öğrencilerim",
      "portal.teacher.students.search_placeholder": "Öğrenci ara...",
      "portal.teacher.students.loading": "Öğrenciler yükleniyor...",
      "portal.teacher.students.none_found": "Öğrenci bulunamadı",
      "portal.teacher.students.error_loading": "Öğrenciler yüklenemedi",

      "portal.teacher.payments.title_outstanding": "Bekleyen Ödemeler",
      "portal.teacher.payments.title_history": "Ödeme Geçmişi",
      "portal.teacher.payments.loading_outstanding": "Yükleniyor…",
      "portal.teacher.payments.loading_history": "Ödemeler yükleniyor…",
      "portal.teacher.payments.no_outstanding": "Bekleyen ödeme yok.",
      "portal.teacher.payments.no_history": "Gösterilecek ödeme yok.",
      "portal.teacher.payments.error_load": "Ödemeler yüklenemedi",
      "portal.teacher.payments.error_send_bill": "Fatura gönderilemedi",
      "portal.teacher.payments.success_send_bill": "Fatura başarıyla gönderildi",
      "portal.teacher.payments.last_update": "Son güncelleme",
      "portal.teacher.payments.sending": "Gönderiliyor...",
      "portal.teacher.payments.send_bill": "Fatura Gönder",
      "portal.teacher.payments.student_fallback": "Öğrenci",

      "portal.student.dashboard.welcome": "Merhaba, {{name}}!",
      "portal.student.dashboard.subtitle": "İlerlemeni takip et ve bir sonraki direksiyon dersini ayarla.",
      "portal.student.dashboard.balance_stat": "Bakiye",
      "portal.student.dashboard.next_lesson_label": "Sıradaki Ders",
      "portal.student.dashboard.next_lesson_at": "saat",
      "portal.student.dashboard.minutes_short": "dk",
      "portal.student.dashboard.meeting_point": "Buluşma noktası",
      "portal.student.dashboard.available_lessons_title": "",
      "portal.student.dashboard.see_more": "Daha fazla",
      "portal.student.dashboard.no_available_lessons": "Şu anda müsait ders bulunmuyor.",
      "portal.student.dashboard.teacher_feedback_title": "Eğitmen Geri Bildirimi",
      "portal.student.dashboard.no_feedback": "Henüz geri bildirim yok. Çalışmaya devam!",
      "portal.student.dashboard.recent_payments_title": "Son Ödemeler",
      "portal.student.payments.column_student": "Öğrenci",
      "portal.student.payments.column_type": "Tip",
      "portal.student.payments.column_description": "Açıklama",
      "portal.student.payments.column_duration": "Süre",
      "portal.student.payments.column_amount": "Tutar",
      "portal.student.payments.items_title": "Dersler ve Sınavlar",
      "portal.student.payments.items_label": "Öğe",
      "portal.student.payments.type_lesson": "DERS",
      "portal.student.payments.type_exam": "SINAV",
      "portal.student.dashboard.no_payments": "Henüz ödeme yok.",
      "portal.student.dashboard.billing_history": "Ödeme Geçmişi",
      "portal.student.dashboard.my_exams_title": "Sınavlarım",
      "portal.student.dashboard.no_exams": "Henüz planlanmış sınav yok.",
      "portal.student.exams.cancel_title": "Sınavı İptal Et",
      "portal.student.exams.cancel_confirm": "Bu sınavı iptal etmek istediğinizden emin misiniz?",
      "portal.student.exams.cancel_button": "Sınavı İptal Et",
      "portal.common.yes_cancel": "Evet, İptal Et",
      "portal.student.dashboard.quick_tip_title": "Günün İpucu",
      "portal.student.dashboard.tip_label": "İpucu",
      "portal.student.dashboard.default_tip": "Şerit değiştirmeden önce daima aynalarınızı kontrol edin!",
      "portal.student.dashboard.resources_title": "Kaynaklar",
      "portal.student.dashboard.theory_material": "Teori Materyalleri",
      "portal.student.dashboard.practice_exams": "Deneme Sınavları",
      "portal.student.dashboard.help_center": "Yardım Merkezi",

      "portal.exams.subtitle": "Planlanmış ve geçmiş sınavlarınız",
      "portal.exams.refresh": "Yenile",
      "portal.exams.create": "Sınav Planla",
      "portal.exams.management": "Sınav Yönetimi",
      "portal.exams.upcoming": "Gelecek Sınavlar",
      "portal.exams.history_title": "Sınav Geçmişi",
      "portal.exams.none_past": "Kaydedilmiş geçmiş sınav bulunamadı.",
      "portal.exams.schedule_new": "Yeni Sınav Planla",
      "portal.exams.date_time": "Tarih ve Saat",
      "portal.exams.location": "Konum / Yer",
      "portal.exams.location_placeholder": "örn. CBR Amsterdam",
      "portal.exams.assign_student": "Öğrenciye Ata",
      "portal.exams.select_student_optional": "Bir öğrenci seçin (isteğe bağlı)",
      "portal.exams.creating": "Oluşturuluyor...",
      "portal.exams.error_create": "Sınav oluşturulamadı",
      "portal.exams.unassigned": "",
      "portal.exams.detail_title": "Sınav Detayları",
      "portal.exams.back_to_list": "Sınavlara Geri Dön",
      "portal.exams.not_found": "Sınav bulunamadı veya yetkiniz yok.",
      "portal.exams.loading_details": "Sınav detayları yükleniyor...",
      "portal.exams.no_location": "Konum ayarlanmamış",
      "portal.exams.result": "Sonuç",
      "portal.exams.passed": "Geçti",
      "portal.exams.failed": "Kaldı",
      "portal.exams.pending": "Beklemede",
      "portal.exams.notes_title": "Sınav Yapıcı Notları",
      "portal.exams.no_notes": "Bu sınava henüz not eklenmemiş.",
      "portal.exams.add_note": "Yeni Not Ekle",
      "portal.exams.max_notes": "Bu sınav için maksimum not sayısına ulaşıldı",
      "portal.exams.note_placeholder": "Gözleminizi buraya yazın...",
      "portal.exams.characters": "karakter",
      "portal.exams.note_empty": "Not boş olamaz",
      "portal.exams.note_success": "Not başarıyla eklendi",
      "portal.exams.note_error": "Not eklenemedi",
      "portal.exams.save_note": "Notu Kaydet",
      "portal.exams.clear": "Temizle",
      "portal.exams.next_exam": "Sıradaki Sınav",
      "portal.exams.next_exam_sub": "Planlanmış bir sınavınız varsa burada görünecektir",
      "portal.exams.no_upcoming": "Gelecek sınav yok.",
      "portal.exams.history": "Geçmiş",
      "portal.exams.history_sub": "Geçmiş sınavlar",
      "portal.exams.none": "Henüz sınav yok.",
      "portal.exams.tap_details": "Detaylar için dokunun",
      "portal.exams.status.upcoming": "GELECEK",
      "portal.exams.status.completed": "TAMAMLANDI",
      "portal.exams.status.passed": "GEÇTİ",
      "portal.exams.status.failed": "KALDI",

      // Auto Page (TR)
      "auto.hero.title": "Siz de kendiniz sürebilmek istemez misiniz?",
      "auto.hero.button": "Deneme Dersi Planla",
      "auto.benefits.high_pass": "Yüksek geçme oranı",
      "auto.benefits.installment": "Taksitli ödeme mümkündür",
      "auto.benefits.experienced": "Deneyimli direksiyon eğitmenleri",
      "auto.details.title": "Ehliyetinize başlamak",
      "auto.details.intro": "Amsterdam'da profesyonel bir sürücü kursu mu arıyorsunuz?",
      "auto.details.description": "İlk direksiyon dersinizi (deneme dersi) bizimle ücretsiz yapın! Universaldrive sürücü kursu Amsterdam'da direksiyon dersleri vermektedir. Universaldrive'da uzman eğitmenler, ehliyetinizi almanız ve her şeyden önce bağımsız, güvenli ve akıcı bir şekilde araç kullanmayı öğrenmeniz için size rehberlik eder.",
      "auto.details.more_text": "İlk deneme dersinden sonra kişisel bir plan oluşturulur. İmkanlarınız ve özel istekleriniz dikkate alınır. Daha sonra gerekli ders sayısı hakkında hemen bir tahmin yapabiliriz.\n\nDireksiyon derslerini sabit bir eğitmen eşliğinde mükemmel bir araçta alırsınız. İsterseniz sizi evinizden alırız ve bir sonraki öğrenci tarafından tekrar evinize bırakılırsınız. Bu sayede çeşitli trafik bölgelerinde araç kullanırsınız ve ayrıca birbirinizden ekstra bir şeyler öğrenirsiniz.\n\nTabii ki sınav sırasında karşılaşabileceğiniz durumlara alışmanız için sınav bölgesinde de pratik yapacağız.",
      "auto.details.read_more": "Daha fazla oku",
      "auto.details.read_less": "Daha az oku",
      "auto.packages.title": "Paketinizi seçin!",
      "auto.packages.pro_max": "PRO MAX",
      "auto.packages.pro": "PRO",
      "auto.packages.premium": "PREMIUM",
      "auto.packages.lessons_40": "40 saat direksiyon dersi",
      "auto.packages.lessons_30": "30 saat direksiyon dersi",
      "auto.packages.lessons_20": "20 saat direksiyon dersi",
      "auto.packages.cbr_exam": "CBR Sınavı dahil",
      "auto.packages.trial_button": "Deneme dersi",
      "auto.callback.title": "Beni geri ara",
      "auto.callback.name": "İsim",
      "auto.callback.phone": "Telefon",
      "auto.callback.submit": "Gönder",
      "auto.callback.auto": "Manuel",
      "auto.callback.motor": "Otomatik",
      "auto.callback.taxi": "Taksi",
      "auto.callback.theory": "Teori kursu",

      // Reviews Section (TR)
      "reviews.title": "Değerlendirmeler",
      "reviews.description": "Öğrencilerimizin bizim hakkımızda ne düşündüğünü görün.",
      "reviews.google": "Google Yorumları",
      "reviews.facebook": "Facebook Yorumları",

      // Demo Lesson Form (TR)
      "demo.title": "Şimdi Bir Deneme Dersi Planla",
      "demo.name": "İsim",
      "demo.phone": "Telefon",
      "demo.email": "E-posta",
      "demo.service": "Hizmet",
      "demo.service_auto_manual": "Araba (B) Manuel",
      "demo.service_auto_automatic": "Araba (B) Otomatik",
      "demo.service_theory": "Teori Kursu",
      "demo.submit": "Gönder",
      "demo.error": "Lütfen tüm zorunlu alanları doğru doldurun.",
      "demo.success": "İsteğiniz başarıyla gönderildi! Ekibimiz yakında sizinle iletişime geçecektir!",
      "demo.error_general": "Bir hata oluştu. Lütfen tekrar deneyin.",

      // Footer (TR)
      "footer.description": "UniversalDrive'daki gelişmelerden sizi haberdar etmek isteriz.",
      "footer.privacy": "Gizlilik Politikası",
      "footer.cookies": "Çerez Politikası",
      "footer.social_media": "🔗 Sosyal Medya:",
      "footer.contact_title": "📍 İletişim Bilgileri",
      "footer.contact_description": "Universal Sürücü Kursu, Amsterdam ve çevresi için",
      "footer.address": "Javastraat 112, 1094 HN Amsterdam",
      "footer.phone": "Tel: 06 16752832",
      "footer.email": "E-posta: info@universaldrive.nl",
      "footer.instagram": "Instagram: @universaldrive",
      "footer.facebook": "Facebook: UniversalDrive",
      "footer.phone_label": "Telefon: +31 6 16752832",
      "footer.digid_title": "🔐 Bizi DigiD ile yetkilendirin",
      "footer.digid_description": "Universaldrive'ı DigiD'niz ile yetkilendirmek için buraya tıklayın.",
      "footer.digid_link": "CBR Yetkilendirme",
      "footer.copyright": "© {{year}} DaaS. Tüm hakları saklıdır | bigO Digital NL tarafından tasarlandı ve uygulandı",

      // Tariff Modal (TR)
      "modal.title": "Paket Talebi",
      "modal.selected_package": "Seçilen paket:",
      "modal.includes": "İçerik:",
      "modal.name_label": "İsim",
      "modal.phone_label": "Telefon",
      "modal.name_placeholder": "İsminiz",
      "modal.phone_placeholder": "Telefon numaranız",
      "modal.cancel": "İptal",
      "modal.submit": "Gönder",
      "modal.loading": "Lütfen bekleyin...",
      "modal.success": "Talebiniz için teşekkürler {name}! İsteğiniz başarıyla gönderildi! Ekibimiz yakında sizinle iletişime geçecektir!",
      "modal.error": "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
      "modal.ok": "Tamam",
      "modal.name_error_min": "İsim en az 2 karakter içermelidir",
      "modal.name_error_max": "İsim en fazla 25 karakter içermelidir",
      "modal.phone_error": "Geçerli bir Hollanda telefon numarası girin",

      // WhatsApp Button (TR)
      "whatsapp.title": "WhatsApp üzerinden bize ulaşın",
      "whatsapp.message": "Merhaba! UniversalDrive'daki direksiyon dersleriyle ilgileniyorum.",

      // Meta (TR)
      "meta.title": "Anasayfa - Amsterdam'ın en iyi sürücü kursu",
      "meta.description": "Anasayfa - Amsterdam'ın en iyi sürücü kursu"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'nl', // Load from localStorage or default to Dutch
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;